import { getYear, PAGE_TITLE_VAR } from "./utils";

const labels = {
  // Labels
  appName: PAGE_TITLE_VAR,
  allRightsReserved: (appName) =>
    `© ${getYear()} ${appName} Todos los derechos reservados`,
  home: {
    title: "Vuélvete millonario jugando la lotería en linea!",
    subtitle:
      "Conviértete en el próximo millonario con tan solo un clic jugando a través de",
    startNow: "Empieza ya!",
    playNow: "Juega ahora!",
    redirecting: "Redirigiendo...",
    redirectingMessage:
      "Por favor espera mientras te redirigimos a la página solicitada.",
    accountLinkNotFound: "No se encontró el link de la cuenta.",
    redirectingError: "Ocurrio un error al redirigir. redirigiendo a inicio...",
    roulette: {
      claim: "Reclamar recompensa",
      cancel: "Cancelar",
      login: "Iniciar",
      register: "Registrarme",
      conditionClaimText:
        "Es necesario iniciar sesión o registrarte para reclamar la recompensa",
      important: "Importante",
    },
    applyingPromotion: "Aplicando promoción...",
    applyingPromotionMessage:
      "Por favor espera mientras aplicamos el código promocional.",
    promotionApplied: "Promoción aplicada exitosamente.",
    promotionAppliedError: "Ocurrio un error al aplicar la promoción.",
    referralMessage:
      "Estimado cliente le informamos que a partir del 15/05/2025 para su cuenta estaremos implementando nuevas rifas y promociones semanales, esta configuracion estará sustitiyendo el bono por deposito configurado actualmente.",
  },
  unknownServerError:
    "Ha ocurrido un error desconocido en el servidor, favor de intentarlo de nuevo.",
  formError: "Por favor corrija los errores en el formulario.",
  tableModal: {
    emptyText: "No se encontraron registros.",
    okButton: "Seleccionar",
    cancelButton: "Cancelar",
    placeholderSearch: "Buscar...",
  },
  breadcrumb: {
    home: "Inicio",
  },
  layout: {
    header: {
      userMenu: {
        verify: "Verificar teléfono",
        referral: "Referidos",
        notifications: "Notificaciones",
        ticketList: "Lista de jugadas",
        transferList: "Transacciones",
        balanceMovements: "Movimientos de saldo",
        changePassword: "Cambiar contraseña",
        cashBalanceReport: "Reporte de cuadre",
        promotion: "Promociones",
        logout: "Salir",
      },
      adminMenu: {
        profile: "Perfil",
        changePassword: "Cambiar contraseña",
        logout: "Salir",
      },
      balance: "Balance:",
      playNow: "Juega ahora!",
      deposit: "Depósito",
      withdraw: "Retiro",
      balanceMovements: "Ver movimientos",
      notifications: {
        title: "Notificaciones",
        all: "Ver todas",
        new: "Nuevo",
        emptyText: "No se encontraron notificaciones.",
      },
    },
  },
  exception: {
    title: "Excepción",
    ACCESS_DENIED: "Acceso denegado",
    ERROR_UNKNOWN:
      "Se produjo un error desconocido, actualice y vuelva a intentarlo.",
    ERROR_NOT_FOUND: "No encontrado",
    UNEXPECTED_ERROR: "Error inesperado",
  },
  login: {
    title: `Bienvenido a`,
    subtitle: "Inicio de sesión al panel administrativo",
    email: {
      label: "Email",
      placeholder: "Introduce tu email.",
    },
    password: {
      label: "Contraseña",
      placeholder: "Introduce tu contraseña.",
    },
    rememberme: "Recordarme",
    forgot: "¿Olvidaste tu contraseña?",
    login: "Iniciar sesión",
    success: "¡Bienvenido!",
    errorMessage: "El email o la contraseña son incorrectos.",
    error: "Error",
  },
  adminPasswordResetForm: {
    title: "Restablecer contraseña",
    subtitle: "Recuperar contraseña",
    verification: "Verificación de cambio de contraseña",
    email: {
      label: "Email",
      placeholder: "Introduce tu email.",
    },
    sendResetCode: "Enviar código",
    loginHere: "Iniciar sesión aquí",
    success: "¡Enviamos un enlace para restablecer tu contraseña!",
    errorMessage: "El email no existe.",
    error: "Error",
    verifying: "Verificando...",
    goToLogin: "Ir a inicio de sesión",
    form1: {
      password: {
        label: "Nueva contraseña",
        placeholder: "Nueva contraseña",
      },
      password_confirmation: {
        label: "Confirmar contraseña",
        placeholder: "Confirmar contraseña",
      },
      success: "Contraseña cambiada exitosamente.",
      error: "Ocurrio un error al cambiar la contraseña.",
      cancel: "Cancelar",
      submit: "Cambiar Contraseña",
      okText: "Aceptar",
    },
    form2: {
      title: "Verificación de cambio de contraseña",
      subtitle: "Introduce el código de verificación que enviamos a tu email.",
      code: {
        label: "Código de verificación",
        placeholder: "Introduce el código de verificación.",
      },
      success: "Código verificado exitosamente.",
      error: "Ocurrio un error al verificar el código.",
      cancel: "Cancelar",
      submit: "Verificar",
    },
  },
  admins: {
    title: "Usuarios (Admin)",
    pageTitleCreate: "Crear usuario (Admin)",
    pageTitleEditing: "Editando usuario (Admin)",
    subtitle: "Lista de usuarios administradores",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar por nombre o email.",
    deletedSuccess: "Usuario eliminado exitosamente.",
    deleteError: "Ocurrio un error al eliminar el usuario.",
    table: {
      emptyText: "No se encontraron usuarios registrados.",
      columns: {
        name: "Nombre",
        email: "Email",
        createdAt: "Creado en",
        updatedAt: "Actualizado en",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro de eliminar este usuario?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      titleEdit: "Editar usuario",
      titleAdd: "Añadir usuario",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      name: {
        label: "Nombre",
        placeholder: "Introduce tu nombre.",
      },
      profile: {
        label: "Perfil",
        placeholder: "Seleccione un perfil (Opcional)",
      },
      email: {
        label: "Email",
        placeholder: "Introduce tu email.",
      },
      password: {
        label: "Contraseña",
        placeholder: "Introduce tu contraseña.",
      },
      password_confirmation: {
        label: "Confirmar contraseña",
        placeholder: "Introduce confirmación de contraseña.",
      },
      status: "Activar/Desactivar",
      roles: "Gestionar roles",
    },
  },
  adminProfiles: {
    title: "Perfiles de Administradores",
    pageTitleCreate: "Crear perfil de administrador",
    pageTitleEditing: "Editando perfil de administrador",
    subtitle: "Lista de perfiles de administradores",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar por nombre.",
    deletedSuccess: "Perfil eliminado exitosamente.",
    deleteError: "Ocurrió un error al eliminar el perfil.",
    table: {
      emptyText: "No se encontraron perfiles registrados.",
      columns: {
        id: "ID",
        name: "Nombre",
        roles: "Roles",
        createdAt: "Creado en",
        updatedAt: "Actualizado en",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro de eliminar este perfil?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      titleEdit: "Editar perfil",
      titleAdd: "Añadir perfil",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre del perfil.",
      },
      roles: "Gestionar roles",
    },
  },
  users: {
    title: "Usuarios",
    pageTitleCreate: "Crear usuario",
    pageTitleEditing: "Editando usuario",
    subtitle: "Lista de usuarios",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar por nombre o email.",
    deletedSuccess: "Usuario eliminado exitosamente.",
    deleteError: "Ocurrio un error al eliminar el usuario.",
    copied: "link copiado al portapapeles",
    copyLinkToClipboard: "Copiar link al portapapeles",
    table: {
      emptyText: "No se encontraron usuarios registrados.",
      columns: {
        users: "Usuarios",
        identification_card: "Cédula",
        user: "Usuario",
        email: "Email",
        birthdate: "Fecha de nacimiento",
        createdAt: "Creado en",
        province: "Provincia",
        country: "Código país",
        commission: "Comisión",
        balance: "Balance",
        withdrawBalance: "Balance retiros",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
          paymentLink: "Link de pago",
          notify: "Notificar",
          paymentClient: {
            SKYCHAIN: "Skychain",
            MONEYGRATOR: "Moneygrator",
            PAYWALL: "Paywall",
            CHARGEMONEY: "Charge Money",
            PAYCOMBAT: "Paycombat",
            MATREVIC: "Matrevic",
          },
        },
      },
    },
    confirm: {
      title: "¿Estás seguro de eliminar este usuario?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      title: "Información de",
      titleEdit: "Editar usuario",
      titleAdd: "Añadir usuario",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      changePassword: "Asignar nueva contraseña",
      goBack: "Atrás",
      loading: "Cargando...",
      joinedAt: "Se unió el",
      referedBy: "Referido por:",
      referralCode: "ID Referido:",
      referralCodeRequired: "ID Referido es requerido.",
      newPasswordAssigned: "Nueva contraseña asignada exitosamente.",
      newPasswordAssignedInfo:
        "Se ha asignado una nueva contraseña de un solo.<br/><br/>usuario: {{user}}<br/>Contraseña: {{password}}",
      is_seller: {
        label: "¿Es Vendedor?",
        yes_label: "Si",
        no_label: "No",
      },
      commission_profile: {
        label: "Perfil de comisión",
        placeholder: "Selecciona el perfil de comisión.",
      },
      transaction_profile: {
        label: "Perfil de transacción",
        placeholder: "Selecciona el perfil de transacción.",
      },
      commission_percentage: {
        label: "Porcentaje de comisión",
        placeholder: "Selecciona el porcentaje de comisión.",
      },
      identification_card: {
        label: "Cédula",
        placeholder: "Introduce tu cédula.",
      },
      firstname: {
        label: "Nombre",
        placeholder: "Introduce tu nombre.",
      },
      lastname: {
        label: "Apellido",
        placeholder: "Introduce tu apellido.",
      },
      email: {
        label: "Email",
        placeholder: "Introduce tu email.",
      },
      whatsapp: {
        label: "Whatsapp",
        placeholder: "Introduce tu whatsapp.",
      },
      birthdate: {
        label: "Fecha de nacimiento",
        placeholder: "Introduce tu fecha de nacimiento.",
      },
      password: {
        label: "Contraseña",
        placeholder: "Introduce tu contraseña.",
      },
      password_confirmation: {
        label: "Confirmar contraseña",
        placeholder: "Introduce confirmación de contraseña.",
      },
      province: {
        label: "Provincia",
        placeholder: "Selecciona tu provincia.",
      },
      country: {
        label: "Código país",
        placeholder: "Seleccione código de país.",
      },
      address: {
        label: "Dirección",
        placeholder: "Introduce tu dirección.",
      },
      city: {
        label: "Ciudad",
        placeholder: "Introduce tu ciudad.",
      },
      paymentClient: {
        label: "Cliente de pago",
        placeholder: "Selecciona el cliente de pago.",
        CHARGEMONEY: "Charge Money",
        MONEYGRATOR: "Moneygrator",
        PAYWALL: "Paywall",
        SKYCHAIN: "Skychain",
        PAYCOMBAT: "Paycombat",
        MATREVIC: "Matrevic",
      },
      status: "Activar/Desactivar",
      email_verified: "Verificación Email",
      whatsapp_verified: "Verificación SMS",
      tabs: {
        generalInfo: {
          title: "Información general",
        },
        assignedLotteries: {
          title: "Loterias asignadas",
        },
        creditCards: {
          title: "Tarjetas de crédito",
        },
        promotions: {
          title: "Promociones",
        },
        referrals: {
          title: "Referidos",
          placeholderSearch: "Buscar por nombre o email.",
          totalCommissions: "Comisiones totales",
          date: {
            label: "Fecha",
            placeholder: "Selecciona una fecha",
            all: "Todos",
            last_7_days: "Últimos 7 días",
            last_15_days: "Últimos 15 días",
            last_30_days: "Últimos 30 días",
          },
          table: {
            emptyText: "No se encontraron referidos.",
            columns: {
              fullname: "Nombre completo",
              email: "Email",
              commission_amount: "Monto de comisión",
              referred_at: "Referido el",
              referreds: "Referidos",
              action: {
                title: "Acciones",
                view: "Ver",
              },
            },
          },
        },
      },
      assignedLotteries: {
        title: "Loterias asignadas",
        subtitle: "Click en el botón añadir para asignar loterias.",
        add: "Añadir",
        table: {
          emptyText: "No se encontraron loterias asignadas.",
          columns: {
            lottery: "Loteria",
            startDate: "Fecha inicio",
            quinielaFirst: "Quiniela 1ra",
            paleFirst: "Pale 1ra",
            tripletaFirst: "Tripleta 1ra",
            superpaleFirst: "Super pale 1ra",
            superquinielaFirst: "Super quiniela 1ra",
            status: {
              title: "Estado",
              active: "Activo",
              inactive: "Inactivo",
            },
            actions: {
              title: "Acciones",
              edit: "Editar",
              delete: "Eliminar",
              moreInfo: "Más info.",
            },
            assignations: "Asignaciones",
          },
          confirmDelete: {
            title: "¿Estás seguro de eliminar esta asignación?",
            content: "Esta acción no se puede deshacer.",
            okText: "Sí, eliminar",
            cancelText: "Cerrar",
            error: "Ocurrio un error al eliminar la asignación.",
            success: "Asignación eliminada exitosamente.",
          },
        },
        moreInfo: {
          title: "Información de loteria {name}",
          startDate: "Fecha inicio",
          status: "Estado",
          prizes: "Premios",
          quinielaFirst: "Quiniela 1ra",
          quinielaSecond: "Quiniela 2da",
          quinielaThird: "Quiniela 3ra",
          paleFirst: "Pale 1ra",
          paleSecond: "Pale 2da",
          tripletaFirst: "Tripleta 1ra",
          tripletaSecond: "Tripleta 2da",
          superpaleFirst: "Super pale 1ra",
          superquinielaFirst: "Super quiniela 1ra",
          pick3Straight: "Pick 3 Straight",
          pick3Box: "Pick 3 Box",
          pick4Straight: "Pick 4 Straight",
          pick4Box: "Pick 4 Box",
        },
        modal: {
          edit: "Editando asignación de loteria",
          add: "Añadir asignación de loteria",
          okText: "Agregar",
          updateText: "Actualizar",
          cancelText: "Cancelar",
        },
        form: {
          rewards: "Premios",
          status: "Activar/Desactivar",
          first: {
            label: "Primera",
            placeholder: "0.00",
          },
          second: {
            label: "Segunda",
            placeholder: "0.00",
          },
          third: {
            label: "Tercera",
            placeholder: "0.00",
          },
          straight: {
            label: "Straight",
            placeholder: "0.00",
          },
          box: {
            label: "Box",
            placeholder: "0.00",
          },
          quiniela: "Quiniela",
          pale: "Pale",
          tripleta: "Tripleta",
          superpale: "Super pale",
          pick3: "Pick 3",
          pick4: "Pick 4",
          superquiniela: "Super quiniela",
          lotteries: {
            label: "Loterias",
            placeholder: "Selecciona la loteria.",
            selectAll: "Seleccionar todas",
          },
          startDate: {
            label: "Fecha inicio",
            placeholder: "DD/MM/YYYY HH:MM:SS",
          },
          quinielaFirst: {
            label: "Quiniela 1ra",
            placeholder: "00-99",
          },
          quinielaSecond: {
            label: "Quiniela 2da",
            placeholder: "00-99",
          },
          quinielaThird: {
            label: "Quiniela 3ra",
            placeholder: "00-99",
          },
          paleFirst: {
            label: "Pale 1ra",
            placeholder: "00-99",
          },
          paleSecond: {
            label: "Pale 2da",
            placeholder: "00-99",
          },
          tripletaFirst: {
            label: "Tripleta 1ra",
            placeholder: "00-99",
          },
          tripletaSecond: {
            label: "Tripleta 2da",
            placeholder: "00-99",
          },
          superpaleFirst: {
            label: "Super pale 1ra",
            placeholder: "00-99",
          },
          superquinielaFirst: {
            label: "Super quiniela 1ra",
            placeholder: "00-99",
          },
        },
      },
      creditCards: {
        title: "Tarjetas de crédito",
        subtitle: "Click en el botón añadir para añadir tarjetas de crédito.",
        add: "Añadir",
        table: {
          emptyText: "No se encontraron tarjetas de crédito registradas.",
          columns: {
            cardNumber: "Número",
            cardExpirationDate: "Expiración",
            country: "País",
            isVerified: {
              title: "Verificada",
              yes: "Si",
              no: "No",
              verified: "Verificada",
              unverified: "No verificada",
            },
            verifyBy: "Verificada por",
            verifyAt: "Verificada en",
            actions: {
              title: "Acciones",
              edit: "Editar",
              delete: "Eliminar",
              moreInfo: "Más info.",
            },
            creditCards: "Tarjetas de crédito",
          },
          confirmDelete: {
            title: "¿Estás seguro de eliminar esta tarjeta de crédito?",
            content: "Esta acción no se puede deshacer.",
            okText: "Sí, eliminar",
            cancelText: "Cerrar",
            error: "Ocurrio un error al eliminar la tarjeta de crédito.",
            success: "Tarjeta de crédito eliminada exitosamente.",
          },
        },
        moreInfo: {
          title: "Información de tarjeta {card_number}",
          startDate: "Fecha inicio",
          status: "Estado",
          prizes: "Premios",
          quinielaFirst: "Quiniela 1ra",
          quinielaSecond: "Quiniela 2da",
          quinielaThird: "Quiniela 3ra",
          paleFirst: "Pale 1ra",
          paleSecond: "Pale 2da",
          tripletaFirst: "Tripleta 1ra",
          tripletaSecond: "Tripleta 2da",
          superpaleFirst: "Super pale 1ra",
          superquinielaFirst: "Super quiniela 1ra",
          pick3Straight: "Pick 3 Straight",
          pick3Box: "Pick 3 Box",
          pick4Straight: "Pick 4 Straight",
          pick4Box: "Pick 4 Box",
        },
        modal: {
          edit: "Editando tarjeta de crédito",
          add: "Añadir tarjeta de crédito",
          okText: "Agregar",
          updateText: "Actualizar",
          cancelText: "Cancelar",
        },
        form: {
          isVerified: "Verificada",
          cardNumber: {
            label: "Número",
            placeholder: "Introduce el número de tarjeta.",
          },
          cardExpirationDate: {
            label: "Fecha de expiración",
            placeholder: "MM/YY",
          },
          country: {
            label: "País",
            placeholder: "Selecciona el país.",
          },
          image: {
            label: "Documento de identidad",
            placeholder: "Subir imagen.",
          },
        },
      },
      promotions: {
        title: "Promociones",
        subtitle: "Aqui se listan las promociones asignadas al usuario.",
        table: {
          columns: {
            code: "Código",
            type: {
              title: "Tipo",
              percentage_next_deposit: "Porcentaje próximo depósito",
              inmeddiate_amount: "Monto inmediato",
              discount_next_purchase: "Descuento próxima jugada",
            },
            useType: {
              title: "Tipo de uso",
              custom_quantity: "Cantidad",
              every_3_months: "Cada 3 meses",
              every_6_months: "Cada 6 meses",
              every_12_months: "Cada 12 meses",
              once_a_day: "Una vez al día (Calendario)",
            },
            quantity: "Cantidad",
            startUseAt: "Inicio uso",
            expiresAt: "Expira en",
            remainingUses: "Usos restantes",
            usedAt: "Usada en",
            state: {
              title: "Estado",
              used: "Usada",
              available: "Disponible",
              expired: "Expirada",
            },
            promotions: "Promociones",
          },
        },
      },
      is_credit_card_enabled: {
        label: "¿Habilitar tarjeta de crédito?",
      },
      disable_withdrawals: "¿Deshabilitar retiros?",
      enable_cash_balance: "¿Habilitar vista cuadre?",
      transfer_fee_disabled: "¿Deshabilitar comisión por transferencia?",
      profit_withdrawal_only: "¿Permitir solo retiros de ganancias?",
      allow_transfer_withdraw_balance:
        "Permitir transferir balance de retiro (a billetera general)",
      allow_crypto_deposit: "Permitir depositar con Criptomonedas",
      allow_crypto_withdraw: "Permitir retiros con Criptomonedas",
      allow_bank_transfer_deposit:
        "Permitir depositar con Transferencia Bancaria (Clásico)",
      allow_bank_transfer_withdraw:
        "Permitir retiros con Transferencia Bancaria",
      allow_transactional_bo_deposit:
        "Permitir depositar con Transferencia Bancaria (Nuevo - Transactional BO)",
      allow_paykassma_deposit: "Permitir depositar con Banreservas",
      allow_kollat_deposit: "Permitir depositar con Kollat",
      allow_auto_apply_transactions:
        "¿Permitir aplicar transacciones automaticamente?",
      allow_live_lottery_module: "¿Permitir módulo de lotería en vivo?",
      allow_roulettes_module: "¿Permitir módulo de ruletas?",
      allow_anguilla_pool_module: "¿Permitir módulo Anguilla Pool?",
      require_identity_verification_for_deposits:
        "¿Requerir verificación de identidad para depósitos?",
      require_identity_verification_for_roulette:
        "¿Requerir verificación de identidad para ruleta?",
      allow_jackpot_module: "¿Permitir módulo de super jackpot?",
      allow_referral_module: "¿Permitir módulo de referidos?",
      allow_flash_draw_module: "¿Permitir módulo de sorteo flash?",
      allow_flash_roulette_module: "¿Permitir módulo de ruleta flash?",
      allow_dog_racing_module: "¿Permitir módulo de juegos virtuales?",
      allow_stars_dominoes_module: "¿Permitir módulo Estrellas Dominó?",
      allow_parchis_module: "¿Permitir módulo Parchis Time?",
      allow_loto_scratch_module: "¿Permitir módulo de raspaditas?",
      allow_sub_accounts: "¿Permitir módulo de sub-cuentas?",
      max_sub_accounts: "Límite de sub-cuentas",
      daily_sales_limit: "Límite de venta diaria",
      emails_allowed_transfer: {
        label: "Emails permitidos para transferir",
        placeholder:
          "Introduce los emails permitidos para transferir, luego presiona enter.",
      },
      deposit_account_group: {
        label: "Grupo de cuentas de depósito",
        placeholder: "Selecciona el grupo de cuentas de depósito.",
      },
    },
    paymentLink: {
      title: "Link de pago",
      user: {
        label: "Cliente",
        placeholder: "Cliente seleccionado.",
        required: "El cliente es requerido.",
        systemPayment: "Sistema de pago",
        selectAnOption: "Seleccione una opción",
        paymentMethod: "Método de pago",
      },
      amount: {
        label: "Monto",
        placeholder: "Introduce el monto.",
        required: "El monto es requerido.",
        number: "El monto debe ser un número.",
        min: "El monto debe ser mayor a 100.",
      },
      generate: "Generar link",
      error: "Ocurrio un error al generar el link de pago.",
      success: "Link de pago generado exitosamente.",
      okText: "Copiar link & cerrar",
      copied: "Link copiado al portapapeles.",
      successMessage: "Para copiar el link de pago presione el botón.",
    },
    notificationForm: {
      title: "Notificar a {email}",
      form: {
        subject: {
          label: "Asunto: ",
          placeholder: "Asunto del mensaje.",
          required: "El titulo es requerido.",
        },
        message: {
          label: "Mensaje: ",
          placeholder: "Introduce el mensaje.",
          required: "El mensaje es requerido.",
        },
        send: "Enviar",
        cancel: "Cancelar",
        success: "Notificación enviada exitosamente.",
        error: "Ocurrio un error al enviar la notificación.",
      },
    },
  },
  transactions: {
    title: "Transacciones",
    pageTitleCreate: "Crear transacción",
    pageTitleViewing: "Viendo transacción",
    subtitle: "Lista de transacciones",
    add: "Añadir",
    view: "Ver",
    cancel: "Cancelar",
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        ticket: {
          label: "Número de ticket",
          placeholder: "Introduce el número de ticket.",
        },
        reference: {
          label: "Referencia",
          placeholder: "Introduce la referencia.",
        },
        status: {
          label: "Estado",
          placeholder: "Selecciona el estado.",
          all: "Todas",
          cancelled: "Cancelado",
          success: "Procesada",
          pending: "Pendiente",
          rejected: "Rechazado",
        },
        type: {
          label: "Tipo",
          placeholder: "Selecciona el tipo.",
        },
        origin: {
          label: "Origen",
          placeholder: "Selecciona el origen.",
        },
        user: {
          label: "Cliente",
          placeholder: "Selecciona el cliente.",
        },
      },
    },
    placeholderSearch: "Buscar por número o usuario.",
    cancelledSuccess: "Transacción cancelada exitosamente.",
    cancelledError: "Ocurrio un error al cancelar la transacción.",
    rejectedSuccess: "Transacción rechazada exitosamente.",
    rejectedError: "Ocurrio un error al rechazar la transacción.",
    approvedSuccess: "Transacción aprobada exitosamente.",
    approvedError: "Ocurrio un error al aprobar la transacción.",
    generateCommissionSuccess: "Comisión generada exitosamente.",
    generateCommissionError: "Ocurrio un error al generar la comisión.",
    paymentClientUnassigned:
      "No posee un cliente de pago asignado, favor contactar a servicio al cliente.",
    requestWithdrawCancellationAlert: {
      title: "Solicitud de cancelación de retiro",
      description:
        "El usuario ha solicitado cancelación del retiro en la fecha {fecha}.",
    },
    requestWithdrawCancellationMessage:
      "El usuario ha solicitado cancelación del retiro en la fecha {fecha}.",
    lockedByProviderMessage:
      "Esta transacción se está procesando vía el proveedor{proveedor}. Se encuentra bloqueada a la espera de confirmación.",
    table: {
      emptyText: "No se encontraron transacciones.",
      columns: {
        code: "Número",
        date: "Fecha",
        type: "Tipo",
        bank: "Banco",
        ticket: "Ticket",
        reference: "Ticket/Referencia",
        origin: "Origen",
        amount: "Monto",
        user: "Correo/Cliente",
        created_by: "Creada Por",
        updated_by: "Actualizada Por",
        created_at: "Creada En",
        updated_at: "Actualizada En",
        cancelled: {
          title: "Estado",
          active: "Activo",
          inactive: "Cancelada",
        },
        status: {
          title: "Estado",
          pending: "Pendiente",
          cancelled: "Cancelado",
          rejected: "Rechazado",
          success: "Procesada",
          approval_pending: "Revisión Pendiente",
          in_refund: "En Devolución",
          refunded: "Devolucionado",
        },
        state: {
          reviewed: "Revisado",
          not_reviewed: "No revisado",
          cancellation_requested: "Cancelación solicitada",
          in_transit: "En Tránsito",
          locked_by_provider: "En Proveedor",
        },
        action: {
          title: "Acciones",
          view: "Ver",
          cancel: "Cancelar",
          reject: "Rechazar",
          moreInfo: "Más info.",
        },
        transactions: "Transacciones",
      },
    },
    confirm: {
      title: "¿Estás seguro que desea cancelar la transacción?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmGenerateCommission: {
      title: "¿Estás seguro que desea generar la comisión?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmReject: {
      title: "¿Estás seguro que desea rechazar la transacción?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmApprove: {
      title: "Confirmar aprobación",
      subtitle: "Se actualizará el balance del usuario.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmReviewed: {
      title: "¿Estás seguro que desea marcar el retiro como revisado?",
      subtitle:
        "Al marcar el retiro como revisado, se podrá proceder a aprobar o rechazar el retiro.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmWarning: {
      title: "¡Atención!",
      subtitle:
        "Actualmente existe un depósito aplicado con el numero de referencia indicado. favor confirmar que la información es correcta.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirmPreview: {
      title: "Confirmar datos de transacción",
      subtitle: "Por favor confirme los datos de la transacción.",
      customer: "Cliente",
      email: "Correo",
      amount: "Monto",
      bank: "Banco",
      reference: "Referencia",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Atrás",
    },
    form: {
      title: "Información de",
      titleView: "Transacción",
      titleProcess: "Añadir nueva transacción",
      save: "Procesar",
      saveAndClose: "Procesar & cerrar",
      saveAndConfirm: "Procesar & confirmar",
      cancelTransaction: "Cancelar transacción",
      rejectTransaction: "Rechazar transacción",
      approveTransaction: "Aprobar transacción",
      generateCommission: "Generar comisión",
      reviewedTransaction: "Revisar retiro",
      reviewedTransactionTitle: "Marcar retiro como revisado",
      reviewedSuccess: "Retiro marcado como revisado exitosamente.",
      requestRefundTransaction: "Solicitar Devolución",
      processRefundTransaction: "Procesar Devolución",
      refund: {
        cardTitle: "Información de Devolución de Depósito",
        requestTitle: "Solicitar Devolución de Depósito",
        requestSubtitle:
          "Complete los datos proporcionados por el cliente para iniciar el proceso de devolución bancaria.",
        processTitle: "Procesar y Completar Devolución",
        processSubtitle:
          "Confirme la transferencia bancaria realizada para completar la devolución del dinero al cliente.",
        reason: {
          label: "Motivo de la Devolución",
          placeholder:
            "Indique el motivo de la devolución (ej: Comentario inapropiado, Cuenta de terceros)",
          required: "El motivo de la devolución es requerido",
        },
        accountNumber: {
          label: "Número de Cuenta Destino",
          placeholder: "Ej: 1029384756",
          required: "El número de cuenta es requerido",
        },
        identificationCard: {
          label: "Cédula / Documento del Titular",
          placeholder: "Ej: 402-1234567-8",
          required: "La cédula o documento es requerido",
        },
        bank: {
          label: "Banco Destino",
          placeholder: "Banco destino para la devolución",
          required: "El banco es requerido",
        },
        reference: {
          label: "Referencia de la Transferencia Bancaria",
          placeholder: "Ej: 89765432",
          required: "La referencia de la transferencia es requerida",
        },
        voucher: {
          label: "Comprobante de Devolución (Voucher)",
        },
        notes: {
          label: "Notas / Observaciones del Pago",
          placeholder: "Observaciones del desembolso o detalles del banco...",
        },
        requestedBy: "Solicitado por",
        processedBy: "Procesado por",
        date: "Fecha",
        requestSuccess: "Solicitud de devolución registrada correctamente",
        processSuccess: "Devolución procesada y completada exitosamente",
      },
      reviewedError: "Ocurrio un error al marcar el retiro como revisado.",
      addUserNote: "Añadir nota al usuario",
      userNotesList: "Lista de notas al usuario",
      goBack: "Atrás",
      loading: "Cargando...",
      joinedAt: "Se unió el",
      vouchersTitle: "Comprobantes",
      uploadOriginVoucher: "Subir comprobante",
      formError: "Por favor corrija los errores en el formulario.",
      showRelatedAccount: "Mostrar cuentas relacionadas",
      super_approval_required_message:
        "La transacción requiere aprobación de un supervisor.",
      super_approval_required_description:
        "La transacción excede el límite permitido para su aprobación, por favor contacte a un supervisor para completar la aprobación.",
      super_approve_required_message: "¡Aprobación de supervisor requerida!",
      super_approve_required_description:
        "La transacción excede el límite permitido, se necesita de su aprobación para completar el proceso.",
      status: {
        label: "Estado",
      },
      deposited_by: {
        label: "Depositado por",
        placeholder: "Depositado por",
        required: "El depositante es requerido.",
      },
      originVoucher: {
        label: "Comprobantes de retiro",
      },
      originBank: {
        label: "Cuenta bancaria administración",
        label2: "Cuenta bancaria (Origen)",
        placeholder: "",
      },
      voucher: {
        label: "Comprobante de depósito",
        placeholder: "Subir comprobante.",
        required: "El comprobante es requerido.",
      },
      date: {
        label: "Fecha",
        placeholder: "DD/MM/YYYY",
      },
      rejectReason: {
        label: "Motivo de rechazo",
        placeholder: "Introduce el motivo de rechazo.",
      },
      reviewNotes: {
        label: "Notas de revisión",
        placeholder: "Introduce las notas de revisión.",
      },
      type: {
        label: "Tipo",
        placeholder: "Selecciona el tipo.",
      },
      ticket: {
        label: "Número de ticket",
        placeholder: "Introduce el número de ticket.",
        modal: {
          title: "Tickets ganadores",
        },
      },
      reference: {
        label: "Referencia",
        placeholder: "Introduce la referencia.",
      },
      origin: {
        label: "Origen",
        placeholder: "Selecciona el origen.",
      },
      amount: {
        label: "Monto",
        placeholder: "Introduce el monto.",
      },
      user: {
        label: "Usuario",
        placeholder: "Selecciona el usuario.",
      },
      email: {
        label: "Correo",
        placeholder: "Introduce el correo.",
      },
      comment: {
        label: "Comentario",
        placeholder: "Introduce el comentario.",
      },
      bank: {
        label: "Banco",
        placeholder: "Selecciona el banco.",
        required: "El banco es requerido.",
      },
      account: {
        label: "Cuenta",
        placeholder: "Introduce la cuenta.",
        labelPaypal: "Email PayPal",
        placeholderPaypal: "Introduce el email de PayPal.",
        labelZelle: "Número Teléfono",
        placeholderZelle: "Introduce el número de teléfono.",
        labelCashApp: "Número Teléfono",
        placeholderCashApp: "Introduce el número de teléfono.",
      },
      account_type: {
        label: "Tipo de cuenta",
        placeholder: "Selecciona el tipo de cuenta.",
        SAVINGS: "Ahorros",
        CHECKING: "Corriente",
      },
      identification_card: {
        label: "Cédula",
        placeholder: "Introduce la cédula.",
      },
      origin_bank: {
        label: "Cuenta bancaria administración",
        placeholder: "Selecciona la cuenta bancaria.",
      },
      origin_voucher: {
        label: "Comprobante de retiro",
        placeholder: "Subir comprobante.",
        required: "El comprobante es requerido.",
      },
      updated_by: {
        label: "Actualizado por",
        placeholder: "Selecciona el usuario.",
      },
      updated_at: {
        label: "Actualizado en",
        placeholder: "Selecciona la fecha.",
      },
      destination_user: {
        label: "Usuario destino",
        placeholder: "Selecciona el usuario destino.",
      },
      preApprove: {
        title: "Panel de fiabilidad del usuario",
        reliabilityScore: "Puntaje de fiabilidad",
        approvedAmountAvg: "Monto promedio de depósitos aprobados",
        approvedDailyQuantityAvg:
          "Cantidad diaria promedio de depósitos aprobados",
        percentRange: "Rango porcentual de depósitos rechazados",
        probabilityOfFraudRule: "Regla de probabilidad de fraude",
        probabilityOfFraudAvg: "Promedio de probabilidad de fraude en retiros",
        preApprovedBy: "Pre aprobado por",
        preApprovedAt: "Pre aprobado en",
        preApprove: "Pre aprobar",
        userBehaviorUnavailable: "Comportamiento del usuario no disponible",
        notAllowedTitle: "No permitido",
        confirmPreApprove: {
          title: "¿Estás seguro que desea pre aprobar la transacción?",
          subtitle:
            "La transacción será marcada como pre aprobada y se acreditará el balance al usuario.",
          confirmButtonText: "Continuar",
          cancelButtonText: "Cancelar",
        },
        success: "Transacción pre aprobada exitosamente.",
        error: "Ocurrio un error al pre aprobar la transacción.",
      },
      user_note: {
        label: "Nota al usuario",
        placeholder: "Introduce la nota al usuario.",
        required: "La nota al usuario es requerida.",
      },
      addNote: {
        title: "Añadir nota a usuario",
        subtitle: "Añadir una nota interna para el usuario.",
        confirmButtonText: "Guardar",
        cancelButtonText: "Cancelar",
        success: "Nota añadida exitosamente.",
        error: "Ocurrio un error al añadir la nota.",
        notAllowed: "No tienes permiso para añadir notas a usuarios.",
      },
    },
    moreInfo: {
      title: "Información de transacción {code}",
      date: "Fecha",
      code: "Número",
      reference: "Ticket/Referencia",
      user: "Correo/Cliente",
      type: "Tipo",
      bank: "Banco",
      origin: "Origen",
      amount: "Monto",
      status: "Estado",
    },
    statuses: {
      all: "Todas",
      pending: "Pendientes",
      processed: "Procesadas",
      cancelled: "Canceladas",
      rejected: "Rechazadas",
      pendingWithdraw: "Retiros pendientes",
      pendingDeposit: "Depósitos pendientes",
      inRefund: "En Devolución",
      refunded: "Devolucionadas",
      hidden: "Ocultas",
    },
    recentDeposits: {
      title: "Depósitos recientes",
      emptyText: "No se encontraron depósitos recientes.",
      error:
        "Debe validar cargando los depositos recientes, para continuar con la aprobarción de la transacción.",
      columns: {
        code: "Número",
        date: "Fecha",
        deposited_by: "Depositado por",
        originBank: "Cuenta bancaria",
        bank: "Banco",
        amount: "Monto",
      },
    },
    recentWithdraws: {
      title: "Retiros recientes",
      emptyText: "No se encontraron retiros recientes.",
      error:
        "Debe validar cargando los retiros recientes, para continuar con la aprobarción de la transacción.",
      columns: {
        code: "Número",
        date: "Fecha",
        originBank: "Cuenta bancaria",
        bank: "Banco",
        account: "Cuenta",
        amount: "Monto",
        probability_of_fraud: "Riesgo",
      },
    },
    accountRelatedAccounts: {
      title: "Cuentas relacionadas",
      emptyText: "No se encontraron cuentas relacionadas.",
      okText: "Cerrar",
      columns: {
        name: "Nombre",
        email: "Email",
        whatsapp: "Whatsapp",
      },
    },
    hasIrregularityAlert: {
      title: "¡Atención!",
      description: "Esta transacción ha sido bloqueada. Motivos detectados:",
      irregularities: {
        BLACKLIST_ACCOUNT:
          "El número de cuenta se encuentra en la lista negra.",
        BLACKLIST_DNI:
          "El documento de identidad se encuentra en la lista negra.",
        HIGH_AMOUNT:
          "El monto de la transacción supera el límite de seguridad.",
        MULTIPLE_BANKS:
          "El usuario ha depositado en demasiados bancos diferentes recientemente.",
        HIGH_ACTIVITY_DEVICE:
          "Múltiples depósitos desde el mismo dispositivo (Multi-cuentas).",
      },
    },
    newUserAlert: {
      title: "¡Atención!",
      description: "Se detecto que el usuario es nuevo",
    },
  },
  blocks: {
    title: "Bloqueos & Limites",
    subtitle: "Lista de bloqueos & limites",
    placeholderSearch: "Buscar por tipo bloqueos o numeros de jugada.",
    add: "Añadir",
    deletedSuccess: "Bloqueo eliminado exitosamente.",
    deletedError: "Ocurrio un error al eliminar el bloqueo.",
    limitAmount: "Límite de monto",
    blockPlay: "Bloqueo de jugada",
    confirm: {
      title: "¿Estás seguro que desea eliminar el bloqueo?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        blockType: {
          label: "Tipo de bloqueo",
          placeholder: "Selecciona el tipo de bloqueo.",
        },
      },
    },
    table: {
      emptyText: "No se encontraron bloqueos & limites.",
      columns: {
        blocks: "Bloqueos & Limites",
        plays: "Jugadas",
        type: "Tipo",
        blockType: "Tipo de bloqueo",
        amount: "Monto",
        startDate: "Fecha inicio",
        endDate: "Fecha fin",
        lotteries: "Loterias",
        status: "Estado",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Bloqueo & Límite",
      titleProcess: "Añadir nuevo bloqueo ó límite",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      cancelTransaction: "Cancelar bloqueo",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteBlock: "Eliminar",
      plays: {
        label: "Jugada",
        placeholder: "Introduce el número de jugada.",
      },
      blockType: {
        label: "Tipo de bloqueo",
        placeholder: "Selecciona el tipo de bloqueo.",
      },
      lotteries: {
        label: "Loterias",
        placeholder: "Selecciona las loterias.",
      },
      amount: {
        label: "Monto",
        placeholder: "Introduce el monto.",
      },
      startDate: {
        label: "Fecha inicio",
        placeholder: "DD/MM/YYYY HH:MM:SS",
      },
      endDate: {
        label: "Fecha fin",
        placeholder: "DD/MM/YYYY HH:MM:SS",
      },
    },
  },
  promotionRaffles: {
    title: "Rifas de promoción",
    subtitle: "Lista de rifas de promoción",
    placeholderSearch: "Buscar por nombre o descripción.",
    add: "Añadir",
    closedSuccess: "Rifa eliminada exitosamente.",
    closedError: "Ocurrio un error al eliminar la rifa.",
    endDateRequired: "La fecha fin es requerida.",
    endDateInvalid: "La fecha fin debe ser mayor a la fecha inicio.",
    initiatedSuccess: "Rifa Iniciada exitosamente.",
    paidSuccess: "Transacción de rifa promocional gerada con éxito.",
    table: {
      emptyText: "No se encontraron rifas de promoción.",
      ticketEmptyText: "No se encontraron tickets.",
      columns: {
        name: "Nombre",
        start_sequence: "Secuencia inicial",
        end_sequence: "Secuencia final",
        start_date: "Fecha inicio",
        end_date: "Fecha fin",
        raffle_date: "Fecha rifa",
        winning_ticket: "Ticket ganador",
        date: "Fecha",
        ticket_number: "Número de ticket",
        reference: "Referencia",
        tickets: "Tickets",
        status: {
          title: "Estado",
          pending: "Pendiente",
          initiated: "Iniciada",
          closed: "Cerrada",
          confirmed: "Confirmada",
          processing: "Procesando",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Rifa de promoción",
      titleProcess: "Añadir nueva rifa de promoción",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      closeRaffle: "Cerrar",
      initiateRaffle: "Iniciar",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteBlock: "Eliminar",
      loadTickets: "Cargar tickets",
      hideTickets: "Ocultar tickets",
      pay: "Generar Transacción (Pagar)",
      only: {
        all: "Todos",
        taken: "Asignados",
        available: "Disponibles",
      },
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      only_referred_by: {
        label: "Solo para referidos por",
        placeholder: "Selecciona el/los usuario(s).",
      },
      raffle_type: {
        label: "Tipo de rifa",
        placeholder: "Selecciona el tipo de rifa.",
        deposit_transaction: "Depósito",
        non_winning_orders: "Tickets no ganadores",
      },
      lottery: {
        label: "Loteria",
        placeholder: "Selecciona la loteria.",
      },
      play_type: {
        label: "Tipo de jugada",
        placeholder: "Selecciona el tipo de jugada.",
        quiniela: "Quiniela",
        pale: "Pale",
        tripleta: "Tripleta",
        superpale: "Super pale",
        superquiniela: "Super quiniela",
        pick3: "Pick 3",
        pick4: "Pick 4",
      },
      prize_type: {
        label: "Tipo de premio",
        placeholder: "Selecciona el tipo de premio.",
        cash: "Efectivo",
        product: "Artículo",
      },
      prize_amount: {
        label: "Monto del premio",
        label2: "Monto del premio a sortear",
        placeholder: "Introduce el monto del premio.",
      },
      prize_product: {
        label: "Artículo (premio)",
        label2: "Artículo a sortear",
        placeholder: "Introduce el artículo a sortear.",
      },
      prize_product_image: {
        label: "Link imagen del artículo (premio)",
        label2: "Link imagen del artículo a sortear",
        placeholder: "Introduce el link de la imagen del artículo a sortear.",
      },
      prize_product_description: {
        label: "Descripción del artículo (premio)",
        label2: "Descripción del artículo a sortear",
        placeholder: "Introduce la descripción del artículo a sortear.",
      },
      amount_per_ticket: {
        label: "Monto por ticket",
        label2: "Monto tickets para ser aplicados",
        placeholder: "Introduce el monto por ticket.",
      },
      start_sequence: {
        label: "Secuencia inicial",
        placeholder: "Introduce la secuencia inicial.",
      },
      end_sequence: {
        label: "Secuencia final",
        placeholder: "Introduce la secuencia final.",
      },
      start_date: {
        label: "Fecha inicio",
        placeholder: "DD/MM/YYYY",
      },
      end_date: {
        label: "Fecha fin",
        placeholder: "DD/MM/YYYY",
      },
      raffle_date: {
        label: "Fecha Sorteo",
        placeholder: "DD/MM/YYYY",
      },
      comments: {
        label: "Comentarios",
        placeholder: "Introduce los comentarios.",
      },
      status: {
        label: "Estado",
        pending: "Pendiente",
        initiated: "Iniciada",
        closed: "Cerrada",
        confirmed: "Confirmada",
        processing: "Procesando",
      },
      winning_ticket: {
        label: "Ticket ganador",
        placeholder: "Introduce el ticket ganador.",
        required: "El ticket ganador es requerido.",
        invalidNumber:
          "El ticket ganador debe ser un número valido. entre {min} y {max}",
      },
    },
    confirmPay: {
      title: "Favor confirmar que vas a pagar la rifa",
      subtitle:
        "Esta acción generará una transacción, como pago de la rifa, a la cuenta del usuario ganador(a).",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    confirm: {
      title: "Favor confirmar que vas a iniciar la rifa",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    closeConfirm: {
      title: "¿Estás seguro que desea cerrar la rifa?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
  },
  scheduledPromotionRaffles: {
    title: "Rifas de promoción programadas",
    subtitle: "Lista de rifas de promoción programadas",
    placeholderSearch: "Buscar por titulo o descripción.",
    add: "Programar",
    closedSuccess: "Programación eliminada exitosamente.",
    closedError: "Ocurrio un error al eliminar la programación.",
    endDateRequired: "La fecha fin es requerida.",
    endDateInvalid: "La fecha fin debe ser mayor a la fecha inicio.",
    initiatedSuccess: "Rifa programada exitosamente.",
    table: {
      emptyText: "No se encontraron programaciones de rifas.",
      columns: {
        name: "Titulo",
        start_sequence: "Secuencia inicial",
        end_sequence: "Secuencia final",
        scheduled_start_date: "Fecha inicio",
        scheduled_end_date: "Fecha fin",
        amount_per_ticket: "Monto por ticket",
        raffle_type: "Tipo de rifa",
        lottery: "Loteria",
        play_type: "Tipo de jugada",
        prize_type: "Tipo de premio",
        prize_amount: "Monto del premio",
        prize_product: "Artículo (premio)",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Programación de rifa de promoción",
      titleProcess: "Añadir nueva",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      closeRaffle: "Cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteBlock: "Eliminar",
      title_f: {
        label: "Título",
        placeholder: "Introduce el título.",
      },
      scheduled_start_date: {
        label: "Fecha inicio",
        placeholder: "DD/MM/YYYY HH:MM:SS",
      },
      scheduled_end_date: {
        label: "Fecha fin",
        placeholder: "DD/MM/YYYY HH:MM:SS",
      },
      raffle_type: {
        label: "Tipo de rifa",
        placeholder: "Selecciona el tipo de rifa.",
        deposit_transaction: "Depósito",
        non_winning_orders: "Tickets no ganadores",
      },
      lottery: {
        label: "Loteria",
        placeholder: "Selecciona la loteria.",
      },
      play_type: {
        label: "Tipo de jugada",
        placeholder: "Selecciona el tipo de jugada.",
        quiniela: "Quiniela",
        pale: "Pale",
        tripleta: "Tripleta",
        superpale: "Super pale",
        superquiniela: "Super quiniela",
        pick3: "Pick 3",
        pick4: "Pick 4",
      },
      prize_type: {
        label: "Tipo de premio",
        placeholder: "Selecciona el tipo de premio.",
        cash: "Efectivo",
        product: "Artículo",
      },
      prize_amount: {
        label: "Monto del premio",
        label2: "Monto del premio a sortear",
        placeholder: "Introduce el monto del premio.",
      },
      prize_product: {
        label: "Artículo (premio)",
        label2: "Artículo a sortear",
        placeholder: "Introduce el artículo a sortear.",
      },
      prize_product_image: {
        label: "Link imagen del artículo (premio)",
        label2: "Link imagen del artículo a sortear",
        placeholder: "Introduce el link de la imagen del artículo a sortear.",
      },
      prize_product_description: {
        label: "Descripción del artículo (premio)",
        label2: "Descripción del artículo a sortear",
        placeholder: "Introduce la descripción del artículo a sortear.",
      },
      amount_per_ticket: {
        label: "Monto por ticket",
        label2: "Monto tickets para ser aplicados",
        placeholder: "Introduce el monto por ticket.",
      },
      start_sequence: {
        label: "Secuencia inicial",
        placeholder: "Introduce la secuencia inicial.",
      },
      end_sequence: {
        label: "Secuencia final",
        placeholder: "Introduce la secuencia final.",
      },
      status: {
        label: "Estado",
        active: "Activo",
        inactive: "Inactivo",
      },
      amount_type: {
        fixed: "Fijo",
        percentage: "Porcentaje",
      },
      initial_amount_type: {
        label: "Tipo de monto inicial",
        placeholder: "Selecciona el tipo de monto inicial.",
      },
      initial_quantity: {
        label: "Monto inicial",
        placeholder: "Introduce el monto inicial.",
      },
      cumulative_amount_type: {
        label: "Tipo de monto acumulado",
        placeholder: "Selecciona el tipo de monto acumulado.",
      },
      cumulative_quantity: {
        label: "Monto acumulado",
        placeholder: "Introduce el monto acumulado.",
      },
    },
    confirm: {
      title: "Favor confirmar que vas a la programación de la rifa",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    deleteConfirm: {
      title: "¿Estás seguro que desea eliminar la programación?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
  },
  promotions: {
    title: "Promociones",
    subtitle: "Lista de promociones",
    placeholderSearch: "Buscar por código o descripción.",
    add: "Añadir",
    deletedSuccess: "Promoción eliminada exitosamente.",
    deletedError: "Ocurrio un error al eliminar la promoción.",
    limitAmount: "Límite de monto",
    blockPlay: "Bloqueo de jugada",
    copiedSuccess: "Link copiado al portapapeles.",
    confirm: {
      title: "¿Estás seguro que desea eliminar la promoción?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        type: {
          label: "Tipo",
          placeholder: "Selecciona el tipo.",
        },
      },
    },
    table: {
      emptyText: "No se encontraron promociones.",
      columns: {
        promotions: "Promociones",
        code: "Código",
        type: {
          title: "Tipo",
          inmeddiate_amount: "Monto inmediato",
          percentage_next_deposit: "Porcentaje/próximo depósito",
          discount_next_purchase: "Descuento/próxima compra",
        },
        useType: {
          title: "Tipo de uso",
          custom_quantity: "Personalizado",
          every_3_months: "Cada 3 meses",
          every_6_months: "Cada 6 meses",
          every_12_months: "Cada 12 meses",
          once_a_day: "Una vez al día (Calendario)",
        },
        uses: "Usos",
        startAt: "Inicio Uso",
        expireAt: "Expiración",
        status: "Estado",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
          copyClientLink: "Copiar link",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Promoción",
      titleProcess: "Añadir nueva promoción",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      cancelTransaction: "Cancelar promoción",
      goBack: "Atrás",
      loading: "Cargando...",
      deletePromotion: "Eliminar",
      qrCode: "Código QR de suscripción",
      validations: "VALIDACIONES",
      additional: "ADICIONALES",
      code: {
        label: "Código",
        placeholder: "Introduce el código.",
      },
      type: {
        label: "Tipo",
        placeholder: "Selecciona el tipo.",
        inmeddiate_amount: "Monto inmediato",
        percentage_next_deposit: "Porcentaje sobre el próximo depósito",
        discount_next_purchase: "Descuento sobre la próxima compra",
      },
      quantity: {
        label: "Cantidad/Porcentaje",
        placeholder: "Introduce la cantidad/porcentaje.",
      },
      useType: {
        label: "Tipo de uso",
        placeholder: "Selecciona el tipo de uso.",
        custom_quantity: "Personalizado",
        every_3_months: "Cada 3 meses",
        every_6_months: "Cada 6 meses",
        every_12_months: "Cada 12 meses",
        once_a_day: "Una vez al día (Calendario)",
      },
      uses: {
        label: "Usos",
        placeholder: "Introduce el número de usos.",
      },
      startAt: {
        label: "Inicio Uso",
        placeholder: "DD/MM/YYYY",
      },
      expireAt: {
        label: "Expiración",
        placeholder: "DD/MM/YYYY",
      },
      status: {
        label: "Estado",
        active: "Activo",
        inactive: "Inactivo",
      },
      oatur: {
        label: "Solo aplicar a los referidos de usuario(s)",
      },
      oaturValues: {
        label: "Usuario(s)",
        placeholder: "Selecciona los usuarios.",
      },
      oaturwnda: {
        label:
          "Solo aplicar a los usuarios registrados sin depósito después de determinada cantidad de días",
      },
      oaturwndaValue: {
        label: "Días",
        placeholder: "Introduce la cantidad de días.",
      },
      oatuwditlqod: {
        label:
          "Solo aplicar a los usuarios sin depósito después de determinada cantidad de días",
      },
      oatuwditlqodValue: {
        label: "Días",
        placeholder: "Introduce la cantidad de días.",
      },
      description: {
        label: "Descripción",
        placeholder: "Introduce la descripción.",
      },
      rafrp: {
        label: "Remover usuario de programa de referidos?",
        placeholder:
          "Marcar para remover al usuario del programa de referidos al usar esta promoción.",
      },
      expire_after_apply: {
        label: "¿Expirar automáticamente horas después de aplicada?",
      },
      expire_after_apply_hours: {
        label: "Horas de validez (después de aplicarse)",
        placeholder: "Introduce la cantidad de horas.",
      },
      only_daily_roulette: {
        label: "Solo aplicable en la Ruleta Diaria",
        tooltip:
          "Si está activo, este bono no se podrá canjear directamente desde la web y solo se otorgará automáticamente a través de la ruleta diaria.",
      },
    },
  },
  birthdayPromotions: {
    title: "Bonos de Cumpleaños",
    subtitle: "Lista de bonos recurrentes",
    placeholderSearch: "Buscar por código.",
    add: "Añadir",
    deletedSuccess: "Bono eliminado exitosamente.",
    deletedError: "Ocurrio un error al eliminar el bono.",
    copiedSuccess: "Link copiado al portapapeles.",
    confirm: {
      title: "¿Estás seguro que desea eliminar el bono?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    table: {
      emptyText: "No se encontraron bonos.",
      columns: {
        code: "Código",
        type: {
          title: "Tipo",
          inmeddiate_amount: "Monto inmediato",
          percentage_next_deposit: "Porcentaje/próximo depósito",
          discount_next_purchase: "Descuento/próxima compra",
        },
        quantity: "Cantidad/Porcentaje",
        status: "Estado",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
          copyClientLink: "Copiar link",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Bono de Cumpleaños",
      titleProcess: "Añadir nuevo bono",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      code: {
        label: "Código",
        placeholder: "Introduce el código.",
      },
      type: {
        label: "Tipo",
        placeholder: "Selecciona el tipo.",
      },
      quantity: {
        label: "Cantidad / Porcentaje",
        placeholder: "Introduce la cantidad o porcentaje.",
      },
      status: "Activo",
      deletePromotion: "Eliminar",
      qrCode: "Código QR de suscripción",
    },
  },
  depositAccountGroups: {
    title: "Grupos de cuentas de depósito",
    subtitle: "Lista de grupos de cuentas de depósito",
    placeholderSearch: "Buscar por nombre.",
    add: "Añadir",
    deletedSuccess: "Grupo de cuentas de depósito eliminado exitosamente.",
    deletedError:
      "Ocurrio un error al eliminar el grupo de cuentas de depósito.",
    addModalTitle: "Añadir Cuenta",
    card: {
      emptyText: "No hay cuentas de depósito registradas.",
      actions: {
        delete: "Eliminar",
        edit: "Editar",
      },
    },
    confirm: {
      title:
        "¿Estás seguro que desea eliminar el grupo de cuentas de depósito?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    table: {
      emptyText: "No se encontraron grupos de cuentas de depósito.",
      columns: {
        id: "ID",
        name: "Nombre",
        accounts: "Cuentas",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        createdAt: "Creado en",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Grupo de cuentas de depósito",
      titleProcess: "Añadir nuevo grupo de cuentas de depósito",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      delete: "Eliminar",
      goBack: "Atrás",
      loading: "Cargando...",
      add: "Añadir cuenta",
      addModalTitle: "Añadir Cuenta",
      cancel: "Cancelar",
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      accounts: {
        label: "Cuentas",
        placeholder: "Selecciona las cuentas.",
      },
      link: {
        label: "Link",
        placeholder: "Introduce el link. ej: http(s)://****",
      },
      status: {
        label: "Estado",
        active: "Activo",
        inactive: "Inactivo",
      },
      account: {
        label: "Cuenta",
        placeholder: "Escriba datos de la cuenta.",
      },
    },
  },
  operationGroups: {
    title: "Grupos Operacionales",
    subtitle: "Lista de grupos operacionales",
    placeholderSearch: "Buscar por nombre.",
    add: "Añadir",
    deletedSuccess: "Grupo operacional eliminado exitosamente.",
    deletedError: "Ocurrio un error al eliminar el grupo operacional.",
    syncMembersSuccess: "Miembros sincronizados exitosamente.",
    syncMembersError: "Ocurrio un error al sincronizar los miembros.",
    addModalTitle: "Gestionar Miembros",
    confirm: {
      title: "¿Estás seguro que desea eliminar el grupo operacional?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    table: {
      emptyText: "No se encontraron grupos operacionales.",
      columns: {
        id: "ID",
        name: "Nombre",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        createdAt: "Creado en",
        type: "Tipo",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
          manageMembers: "Gestionar Miembros",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Grupo operacional",
      titleCreate: "Añadir nuevo grupo operacional",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      delete: "Eliminar",
      goBack: "Atrás",
      loading: "Cargando...",
      cancel: "Cancelar",
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      type: {
        label: "Tipo de Transacción",
        placeholder: "Seleccione el tipo de transacción.",
      },
      status: {
        label: "Estado",
        active: "Activo",
        inactive: "Inactivo",
      },
      rules: {
        title: "Configuración de Reglas",
        minAmount: {
          label: "Monto Mínimo",
          placeholder: "Monto mínimo",
        },
        maxAmount: {
          label: "Monto Máximo",
          placeholder: "Monto máximo",
        },
        maxFraudRisk: {
          label: "Máximo Riesgo de Fraude (%)",
          placeholder: "Riesgo máximo (0-100)",
        },
        allowedAccounts: {
          label: "Grupos de Cuentas Permitidas",
          placeholder: "Seleccione grupos de cuentas",
        },
        allowedBanks: {
          label: "Bancos Permitidos",
          placeholder: "Agregue bancos permitidos",
        },
        excludedStatuses: "Estados a Excluir",
        placeholder: "Seleccione estados a excluir",
      },
      tabs: {
        operations: "Reglas Operativas",
        movements: "Reglas de Movimientos",
      },
      movementRules: {
        title: "Reglas de Movimientos de Documentos",
        subtitle:
          "Configura el acceso para la carga de estados de cuenta y comprobantes bancarios en Transactional BO.",
        allowedAccounts: {
          label: "Cuentas Bancarias Permitidas para Movimientos",
          placeholder:
            "Seleccione las cuentas permitidas para subir movimientos...",
        },
        onlyOwnDocuments: {
          label: "Solo ver documentos propios",
          description:
            "Si se activa, los miembros de este grupo solo podrán visualizar y consultar los archivos de movimientos que ellos mismos hayan subido en Transactional BO.",
        },
        selectAll: "Seleccionar todas",
        clearAll: "Limpiar selección",
      },
    },
  },
  lotteries: {
    title: "Loterias",
    pageTitleCreate: "Crear lotería",
    pageTitleEditing: "Editando lotería",
    subtitle: "Lista de loterias",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar por nombre o abreviado.",
    deletedSuccess: "Loteria eliminada exitosamente.",
    deleteError: "Ocurrio un error al eliminar la loteria.",
    table: {
      emptyText: "No se encontraron loterias registradas.",
      columns: {
        lotteries: "Loterias",
        name: "Loteria",
        country: "Pais Sorteo",
        abbreviated: "Abreviado",
        createdAt: "Creado en",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro de eliminar esta loteria?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      titleEdit: "Editar loteria",
      titleAdd: "Añadir loteria",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      baseInfo: "Datos básicos",
      startTime: "Horario de inicio",
      endTime: "Horario de cierre",
      rewards: "Premios",
      activationPlays: "Habilitar jugadas adicionales",
      copyMondayTimeToOtherDate: "Poner la hora del lunes a las demás fechas",
      logo: "Suba aqui su logo de loteria",
      name: {
        label: "Loteria",
        placeholder: "Introduce tu loteria.",
      },
      abbreviated: {
        label: "Abreviado",
        placeholder: "Introduce tu abreviado.",
      },
      country: {
        label: "Pais Sorteo",
        placeholder: "Seleccione el Pais de sorteo",
      },
      timezone: {
        label: "Zona horaria",
        placeholder: "Seleccione la zona horaria",
      },
      status: "Activar/Desactivar",
      mondayTime: {
        label: "Lunes",
        placeholder: "--:--",
      },
      tuesdayTime: {
        label: "Martes",
        placeholder: "--:--",
      },
      wednesdayTime: {
        label: "Miércoles",
        placeholder: "--:--",
      },
      thursdayTime: {
        label: "Jueves",
        placeholder: "--:--",
      },
      fridayTime: {
        label: "Viernes",
        placeholder: "--:--",
      },
      saturdayTime: {
        label: "Sábado",
        placeholder: "--:--",
      },
      sundayTime: {
        label: "Domingo",
        placeholder: "--:--",
      },
      first: {
        label: "Primera",
        placeholder: "0.00",
      },
      second: {
        label: "Segundo",
        placeholder: "0.00",
      },
      third: {
        label: "Tercera",
        placeholder: "0.00",
      },
      straight: {
        label: "Straight",
        placeholder: "0.00",
      },
      box: {
        label: "Box",
        placeholder: "0.00",
      },
      quiniela: "Quiniela",
      pale: "Pale",
      tripleta: "Tripleta",
      superpale: "Super pale",
      pick3: "Pick 3",
      pick4: "Pick 4",
      superquiniela: "Super quiniela",
      description: {
        label: "Información adicional",
        placeholder: "Introduce la descripción.",
        tooltip:
          "La información adicional se mostrará en la página detalles de resultados de la lotería.",
      },
      external_name: {
        label: "Nombre externo",
        placeholder: "Introduce el nombre externo.",
        tooltip:
          "El nombre externo se utilizará para integraciones con sistemas externos.",
      },
      api_result_enabled: {
        label: "Habilitar resultados API",
        tooltip:
          "Si está habilitado, los resultados de esta lotería se obtendrán a través de la API externa.",
      },
    },
  },
  raffles: {
    title: "Sorteos",
    pageTitleCreate: "Añadir sorteo",
    pageTitleEditing: "Editando sorteo",
    subtitle: "Listado de sorteos",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar por fecha, numero o loteria.",
    deletedSuccess: "Sorteo eliminado exitosamente.",
    deleteError: "Ocurrio un error al eliminar el sorteo.",
    processingError: "Ocurrio un error al procesar el sorteo.",
    processingSuccess: "Sorteo procesado exitosamente.",
    deleteErrorNotification: {
      title:
        "Algunas trasacciones asociadas a este sorteo no pueden ser canceladas.",
      btnDownload: "Descargar reporte",
    },
    table: {
      emptyText: "No se encontraron sorteos registrados.",
      columns: {
        raffles: "Sorteos",
        date: "Fecha",
        createdAt: "Creado en",
        updatedAt: "Actualizado en",
        createdBy: "Creado por",
        updatedBy: "Actualizado por",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro de eliminar este sorteo?",
      subtitle: "Esta acción no se puede deshacer.",
      subtitle2:
        "Las transacciones generadas por este sorteo seran canceladas. Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    confirmAssignResults: {
      title: "Confirmar asignación de resultados!",
      subtitle:
        "Se asignarán los resultados del sorteo seleccionado al sorteo de la fecha indicada.",
      date: {
        label: "Fecha del sorteo a asignar resultados",
        placeholder: "DD/MM/AAAA",
      },
      confirmButtonText: "Si, confirmar",
      cancelButtonText: "Cancelar",
      confirmedSuccess: "Resultados asignados exitosamente.",
    },
    confirmRaffle: {
      title: "Confirmar sorteo!",
      subtitle: "¿Estás seguro de procesar este sorteo?",
      subtitle2:
        "Una vez procesado los sorteos seleccionados se procederá a ejecutar el proceso <b>Jugadas Ganadoras</b>.",
      confirmButtonText: "Si, confirmar",
      cancelButtonText: "Cancelar",
      confirmedSuccess: "Sorteo confirmado exitosamente.",
      missingPick3Title: "¿ESTA SEGURA QUE QUIERE CONFIRMAR SIN EL PICK3?",
      missingPick3Subtitle:
        "El sorteo no tiene asignado un resultado para el pick3, ¿desea continuar?",
    },
    form: {
      titleEdit: "Editar sorteo",
      titleAdd: "Añadir sorteo",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      cleanRow: "Limpiar fila.",
      submitDateError: "Debe seleccionar una fecha para ejecutar acción.",
      confirm: "Confirmar",
      createdBy: "Creado por",
      createdAt: "Fecha de creación",
      confirmedBy: "Confirmado por",
      confirmedAt: "Fecha de confirmación",
      allNumbersRequired:
        "Todos los campos son requeridos en la loteria ({lottery}).",
      assignResults: "Asignar resultados",
      proccessWinningPlays: "Re-procesar sorteo",
      more: "Más opciones",
      date: {
        label: "Fecha",
        placeholder: "--/--/----",
      },
      lotteries: "Loterías",
      firstPrize: {
        label: "Primera",
        placeholder: "00-99",
      },
      secondPrize: {
        label: "Segunda",
        placeholder: "00-99",
      },
      thirdPrize: {
        label: "Tercera",
        placeholder: "00-99",
      },
      fourthPrize: {
        label: "Cuarta",
        placeholder: "00-99",
      },
      fifthPrize: {
        label: "Quinta",
        placeholder: "00-99",
      },
      pick3Prize: {
        label: "Pick 3",
        placeholder: "###",
      },
      pick4Prize: {
        label: "Pick 4",
        placeholder: "####",
      },
      delete: "Eliminar",
      update: "Actualizar",
    },
  },
  joinOurMailList: {
    title: "Únase a nuestra lista de correo para recibir las últimas noticias.",
    form: {
      email: {
        label: "Correo",
        placeholder: "Dirección de correo electrónico.",
      },
      submit: "Subscribir",
      success: "Suscrito satisfactoriamente.",
      successMessage:
        "Gracias por suscribirse a nuestra lista de correo, lo mantendremos informado de todas las novedades de nuestro portal.",
      error: "Error",
      errorMessage:
        "Ocurrio un error al suscribirse a nuestra lista de correo.",
    },
  },
  howToPlay: {
    title: "¿Cómo jugar?",
    subtitle: "Registrate y empieza a ganar!",
    subtitle2: "Recarga tu cuenta y empieza a ganar!",
    step: [
      {
        title: "Registrate",
        description: "",
        link: "register",
      },
      {
        title: "Recarga Tu Cuenta",
        description: "",
        link: "transaction-request",
        query: { type: "DEPOSIT" },
      },
      {
        title: "Juega y Gana!",
        description: "",
        link: "buy",
      },
    ],
  },
  faqs: {
    title: "Preguntas frecuentes",
    subtitle: "Preguntas frecuentes",
    subtitle2: "¿No encuentras lo que buscas?. Contáctanos.",
    watchTheVideo: "Para más información mira el siguiente video",
    playVideo: "Ver Video",
    appDownload: {
      title: "Intrucciones para descargar app (Android & iOS)",
      subtitle: "Descarga Nuestras Apps Para Android y Iphone",
      android: "Instalar app para Android paso a paso",
      ios: "Instalar app para Iphone paso a paso",
    },
  },
  bigWinner: {
    title: "Grandes Ganadores",
    notResults: "No se encontraron ganadores",
    loading: "Cargando ganadores...",
  },
  contactUsForm: {
    title: "Contáctenos",
    subtitle: "Contacto",
    form: {
      name: {
        label: "Nombre",
        placeholder: "Su nombre",
      },
      email: {
        label: "Correo electrónico",
        placeholder: "Introduzca la dirección de correo electrónico",
      },
      subject: {
        label: "Asunto",
        placeholder: "Escribe tu asunto",
      },
      message: {
        label: "Mensaje",
        placeholder: "escribe tu mensaje",
      },
      submit: "Enviar",
      success: "Gracias por contactarnos.",
      successEmail: "en breve nos pondremos en contacto contigo.",
      error: "Error",
      errorMessage: "Ocurrio un error al enviar el mensaje.",
    },
  },
  problemReportForm: {
    title: "Reportar un problema",
    subtitle: "Gracias por contactarnos",
    details:
      "Estamos comprometidos con la calidad del servicio al cliente y lamentamos que haya tenido un problema. Analizaremos cuidadosamente su situación y haremos nuestro mejor esfuerzo para resolverla lo mas pronto posible. Tu opinión nos permite para ser mejores.",
    form: {
      name: {
        label: "Nombre",
        placeholder: "Su nombre",
      },
      email: {
        label: "Correo electrónico",
        placeholder: "Introduzca la dirección de correo electrónico",
      },
      phone: {
        label: "Número telefónico",
        placeholder: "Introduzca el número de teléfono",
      },
      message: {
        label: "Problema",
        placeholder: "Descripción del problema",
      },
      attachments: {
        label: "Adjuntar archivos",
        placeholder: "Adjuntar",
        warning: "¡Atención!",
        maxFiles: "Máximo 5 archivos adjuntos",
      },
      submit: "Enviar",
      success: "Gracias por contactarnos.",
      successEmail: "En breve nos pondremos en contacto.",
      error: "Error",
      errorMessage: "Ocurrio un error al enviar el mensaje.",
    },
  },
  referral: {
    title: "Referidos",
    subtitle: "Refiere a tus amigos y gana dinero!",
    subtitle2: "Gana {reward} por cada referido que se registre con tu código.",
    viewReferralRules: "Ver reglas de referidos",
    viewAllMyReferrals: "Ver todos mis referidos",
    youReceive: "Recibes",
    referralCode: "ID Referido",
    referralLink: "Enlace de referido",
    inviteFiends: "Invita a tus amigos",
    copied: "Copiado al portapapeles",
    loadingRules: "Cargando reglas...",
    arrmDisabled:
      "Para habilitar esta opcion debe contactase con nosotros via whatsapp",
    contactViaWhatsApp: "Contactar via WhatsApp",
    qrModal: {
      subtitle: "Refiere a tus amigos y gana dinero!",
    },
    allReferralModal: {
      title: "Todos mis referidos",
      subtitle:
        "Todos los usuarios que se han registrado con tu código ó link de referido.",
      table: {
        emptyText: "No se encontraron referidos.",
        columns: {
          ID: "ID de usuario",
          commission: "Comisión obtenida (RD$)",
          date: "Fecha de registro",
          paid: "Pagado",
        },
      },
    },
    tieredReferralSystem: {
      title: "Sistema Referidos Por Niveles",
      description: `<p>Refiere y gana, recibe un % de comisión por las recargas realizadas por tus referidos.</p><p>Envía el link de referidos directo a los usuarios interesados y usted estará recibiendo el {percentage1}% de comisión (nivel 1) de todos los depósitos realizados. A continuación si el usuario registrado bajo su link de afiliado sigue recomendando y registra más usuario usted estará recibiendo el {percentage2}% (nivel 2) de comisión del monto depósitado.</p>`,
      level1: {
        label: "Nivel 1",
      },
      level2: {
        label: "Nivel 2",
      },
    },
  },
  ticketList: {
    title: "Lista de jugadas",
    subtitle: "Listado de jugadas realizadas",
    placeholderSearch: "Buscar por número...",
    showWinningTickets: "Mostrar Tickets Ganadores",
    advanceSearch: "Búsqueda avanzada",
    startDate: "Fecha inicio",
    endDate: "Fecha fin",
    table: {
      emptyText: "No se encontraron jugadas registradas.",
      columns: {
        date: "Fecha",
        code: "Número",
        totalAmount: "Monto total",
        status: {
          title: "Estado",
          processed: "Procesado",
          cancelled: "Cancelado",
          paid: "Pagado",
        },
        wonTotalAmount: "Monto ganado",
        action: {
          title: "Acciones",
          view: "Ver",
          cancel: "Cancelar",
        },
        tickets: "Jugadas",
      },
    },
    confirmCancellation: {
      title: "Cancelar ticket",
      content: "Favor de confirmar que desea cancelar el ticket #{code}.",
      note: "Notas:",
      note1:
        "No se permite la cancelacion de tickets que contengan loterias cerradas.",
      note2:
        "No se permite la cancelacion de tickets pasado {count} minutos luego de su compra.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
      errorCancellation: "Ocurrio un error al cancelar el ticket.",
      successCancellation: "Ticket cancelado exitosamente.",
    },
  },
  ticketView: {
    title: "Jugada",
    subtitle: "Detalle de jugada",
    loadingText: "Cargando...",
    playDetails: "DETALLES DE JUGADA #",
    guaranteePayment: "Garantia de pago",
    dateLabel: "Fecha: ",
    phoneLabel: "Tel: ",
    ticketNoLabel: "Ticket #: ",
    totalLabel: "Total",
    subtotalLabel: "Subtotal",
    discountAmountLabel: "Descuento",
    promotionLabel: "Promoción: ",
    wonTotalLabel: "Ganado",
    checkTicketLabel: "Revise su ticket",
    noPaymentLabel: "No pagamos sin ticket",
    sellerLabel: "Vendedor",
    clientLabel: "Cliente",
    statusLabel: "Estado: ",
    print: "Imprimir",
    shareTitle: "Compartir ticket",
    copiedToClipboard: "Copiado al portapapeles",
    shareError: "Ocurrio un error al compartir el ticket.",
    rebuyError: "Ocurrio un error al repetir la jugada.",
    shareBtn: "Compartir",
    reBuyBtn: "Repetir jugada",
    errorAreNotPaidLabel: "No se pagan errores",
    table: {
      type: "Tipo Jugada/Loterías",
      typeShort: "PR",
      numbers: "Números",
      lottery: "Loterias",
      amount: "Valor",
      wonAmount: "Ganado",
      playTypes: {
        quiniela: "Quiniela",
        pale: "Pale",
        tripleta: "Tripleta",
        superpale: "Super pale",
        superquiniela: "Super quiniela",
        chance: "Chance",
        doble_chance: "Doble Chance",
        triple_chance: "Triple Chance",
        superquinielaDescription:
          "Haga clic para ver los detalles de la jugada",
      },
    },
    statuses: {
      cancelled: "Cancelado",
      processed: "Procesado",
    },
    confirmCancellation: {
      title: "Cancelar ticket",
      content: "Favor de confirmar que desea cancelar el ticket #{code}.",
      note: "Notas:",
      note1:
        "No se permite la cancelacion de tickets que contengan loterias cerradas.",
      note2:
        "No se permite la cancelacion de tickets pasado {count} minutos luego de su compra.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
      errorCancellation: "Ocurrio un error al cancelar el ticket.",
      successCancellation: "Ticket cancelado exitosamente.",
      cancelLabel: "Cancelar",
    },
  },
  loginForm: {
    title: "Acceso",
    subtitle: "Bienvenido de nuevo a",
    text: "Iniciar sesión",
    form: {
      email: {
        label: "Cédula ó correo electrónico",
        placeholder: "Cédula ó correo electrónico",
      },
      password: {
        label: "Contraseña",
        placeholder: "Ingresa tu contraseña",
      },
      submit: "Iniciar sesión ahora",
      forgotPassword: "¿Contraseña olvidada?",
      newInApp: (appName) => `¿Nuevo en ${appName}?`,
      register: "Registrarse aquí",
      error: "Error",
      errorMessage: "Ocurrio un error al iniciar sesión.",
      notRobot: "Por favor asegúrate de que eres humano.",
      success: "¡Bienvenido!",
      cpModal: {
        changeTemporaryPassword: "Cambiar contraseña temporal",
        changeTemporaryPasswordMessage:
          "Parece que estás usando una contraseña temporal. Por favor, cambia tu contraseña para continuar.",
        newPassword: {
          label: "Nueva contraseña",
          placeholder: "Nueva contraseña",
          required: "La nueva contraseña es requerida.",
          minLength: "La nueva contraseña debe tener al menos 6 caracteres.",
        },
        confirmPassword: {
          label: "Confirmar contraseña",
          placeholder: "Confirmar contraseña",
          required: "La confirmación de la contraseña es requerida.",
          confirmed: "Las contraseñas no coinciden.",
        },
        change: "Cambiar contraseña",
        cancel: "Cancelar",
        correctErrors: "Por favor, corrija los errores antes de continuar.",
        passwordChanged: "Contraseña cambiada exitosamente.",
      },
    },
  },
  changePasswordForm: {
    title: "Cambiar contraseña",
    form: {
      current_password: {
        label: "Contraseña actual",
        placeholder: "Contraseña actual",
      },
      password: {
        label: "Nueva contraseña",
        placeholder: "Nueva contraseña",
      },
      password_confirmation: {
        label: "Confirmar contraseña",
        placeholder: "Confirmar contraseña",
      },
      success: "Contraseña cambiada exitosamente.",
      error: "Ocurrio un error al cambiar la contraseña.",
      cancel: "Cancelar",
      submit: "Cambiar Contraseña",
    },
  },
  passwordResetForm: {
    title: "Restablecer la contraseña",
    verification: "Verificación de cambio de contraseña",
    form: {
      goBack: "Volver",
      forgetEmailHelpText:
        "Si no recibe el correo electrónico o no tiene acceso al mismo, por favor póngase en contacto con nuestro equipo de soporte a través de los números de WhatsApp que aparecen a continuación.",
      forgetEmailHelp: "¿Olvidaste o no tienes acceso a tu correo?",
      chooseMethod: "Elija un método para restablecer su contraseña:",
      smsSuccessMessage:
        "Se ha enviado una contraseña temporal vía SMS. Favor cambiarla después de iniciar sesión.",
      selectMethodError: "Por favor seleccione un método de recuperación.",
      phone_number: {
        label: "Confirmar número de teléfono",
        placeholder: "Ej: (809) 555-5555",
        helpText:
          "El número de teléfono debe coincidir con el que se nuestra en la selección anterior.",
      },
      email: {
        label: "Correo electrónico",
        placeholder: "Dirección de correo electrónico",
      },
      submit: "Enviar",
      sendSms: "Enviar SMS",
      success: "¡Correo Enviado!",
      successMessage:
        "Se ha enviado un correo electrónico con instrucciones para restablecer la contraseña.",
      error: "Ocurrio un error al enviar el correo electrónico.",
      goToLogin: "Volver a pantalla de acceso",
      okText: "Aceptar",
    },
    form1: {
      password: {
        label: "Nueva contraseña",
        placeholder: "Nueva contraseña",
      },
      password_confirmation: {
        label: "Confirmar contraseña",
        placeholder: "Confirmar contraseña",
      },
      success: "Contraseña cambiada exitosamente.",
      error: "Ocurrio un error al cambiar la contraseña.",
      cancel: "Cancelar",
      submit: "Cambiar Contraseña",
      okText: "Aceptar",
    },
    goToHome: "ir a inicio",
    goToLogin: "Acceder",
  },
  registerForm: {
    title: "Registrarse",
    subtitle: "Registro",
    accept: "Aceptar",
    form: {
      promotion_code: {
        label: "Código de promoción (Opcional)",
        placeholder: "Ex: XXXXXX",
      },
      firstname: {
        label: "Nombre",
        placeholder: "Primer nombre",
      },
      lastname: {
        label: "Apellido",
        placeholder: "Apellido",
      },
      identificationCard: {
        label: "Cédula",
        placeholder: "Cédula",
      },
      email: {
        label: "Dirección de correo electrónico",
        placeholder: "Dirección de correo electrónico",
      },
      birthdate: {
        label: "Fecha de nacimiento",
        placeholder: "Fecha de nacimiento",
      },
      referralCode: {
        label: "ID de Referencia (Opcional)",
        placeholder: "Ex: XXXXXX",
      },
      password: {
        label: "Contraseña",
        placeholder: "Ingresa tu contraseña",
      },
      passwordConfirm: {
        label: "Confirmar contraseña",
        placeholder: "Confirma tu contraseña",
      },
      whatsapp: {
        label: "Whatsapp",
        placeholder: "Número de Whatsapp",
      },
      city: {
        label: "Ciudad",
        placeholder: "Ciudad",
      },
      province: {
        label: "Provincia",
        placeholder: "Provincia",
      },
      country: {
        label: "Código",
        placeholder: "Código",
      },
      address: {
        label: "Dirección",
        placeholder: "Dirección",
      },
      agreeWidth: "Estoy de acuerdo con las",
      privacityPolicy: "política de privacidad",
      terms: "términos y condiciones",
      notRobot: "Por favor asegúrate de que eres humano.",
      aceptTerms: "Debes aceptar los términos y condiciones.",
      submit: "Regístrate ahora",
      needHelp: "¿Necesitas asistencia o apoyo?",
      haveAccount: "¿Ya tienes una cuenta?",
      inHere: "Entra aquí",
      success: "Gracias por registrarte.",
      error: "Error",
      errorMessage: "Ocurrio un error al registrarte.",
      verifiedEmailSend: "Se ha enviado un correo electrónico de verificación.",
      isMinor: "Debe ser mayor de edad para usar esta plataforma.",
    },
    confirm: {
      title: "Política de privacidad, términos y condiciones",
      content:
        "Debes aceptar los términos y condiciones y política de privacidad.",
      okText: "Aceptar",
      cancelText: "Cancelar",
    },
  },
  results: {
    title: "Resultados",
    resultsOf: "Resultados del",
    loadingText: "Cargando resultados...",
    notResults: "No se encontraron resultados para esta fecha.",
    raffle: "Sorteo",
    raffleDateLabel: "Fecha del sorteo:",
    lotteryCloseTimeLabel: "Hora Cierre",
  },
  privacyPolicies: {
    title: "Políticas de privacidad",
    subtitle: "Políticas de privacidad",
    loadingText: "Cargando políticas de privacidad...",
    notResults: "No se encontraron políticas de privacidad.",
  },
  termsAndConditions: {
    title: "Términos y condiciones",
    subtitle: "Términos y condiciones",
    loadingText: "Cargando términos y condiciones...",
    notResults: "No se encontraron términos y condiciones.",
  },
  playNow: {
    title: "!Juega Ahora!",
  },
  cart: {
    title: "Listado de jugadas",
    add: "Agregar jugada",
    ticketList: "Lista de jugadas",
    selectLotteries: "Selecciona las loterías",
    empty: "No ha agregado jugada al carrito.",
    emptyText:
      "Puedes agregar productos a tu carrito haciendo click en el botón de agregar jugada.",
    notAvailableLottery:
      "Esta lotería no está disponible por el momento, esta jugada no podrá ser procesada.",
    date: "Fecha:",
    total: "TOTAL:",
    goToCheckout: "Pagar",
    deleteError: "Ocurrio un error al eliminar la jugada.",
    deleteSuccess: "Jugada eliminada exitosamente.",
    playTypes: {
      quiniela: "Quiniela",
      pale: "Pale",
      tripleta: "Tripleta",
      superpale: "Super pale",
      superquiniela: "Super quiniela",
      chance: "Chance",
      doble_chance: "Doble Chance",
      triple_chance: "Triple Chance",
      superquinielaDescription: "Haga clic para ver los detalles de la jugada",
    },
    table: {
      play: "Jugada",
      type: "Tipo de jugada",
      lottery: "Loteria",
      numbers: "Números",
      amount: "Monto",
      action: {
        title: "Acción",
        remove: "Eliminar Jugada",
      },
    },
    popout: {
      lotteriesTitle: "Loteria(s)",
      playListTitle: "Jugada(s)",
      validatePlays: "Validación",
      next: "Siguiente",
      prev: "Anterior",
      superpale: "Super pale",
      cancel: "Cancelar",
      addPlays: "Agregar",
      addPlay: "Agregar jugada",
      loadingMessage: "Cargando loterias...",
      lotteriesError: "Debe seleccionar al menos una loteria.",
      lotteriesSuperpaleError:
        "Debe seleccionar dos loterias o más para el super pale.",
      mixPlaysError:
        "Al menos dos números diferentes son requeridos, para procesar la mezcla de números.",
      mixError:
        "La(s) siguiente(s) jugada(s) no puede(n) ser mezclada(s), debe ser números entre 00-99:",
      playsError: "Debe completar al menos una jugada.",
      addNewEntry: "Agregar nueva jugada",
      required: "Requerido",
      amount: "Monto",
      play: "Jugada",
      playType: "Tipo de jugada",
      numbers: "Números",
      numbersPlaceholder: "00-00-00",
      superPalePlaceholder: "00-00",
      amountPlaceholder: "0.00",
      quiniela: "Quiniela",
      pale: "Pale",
      tripleta: "Tripleta",
      addPlaysSuccess: "Jugada agregada exitosamente.",
      totalLabel: "Total",
      mix: "Mezclar",
    },
    payment: {
      title: "Revisa tu ticket",
      payTicket: "Pagar Ticket",
      totalTicket: "Total:",
      success: "Ticket pagado & generado exitosamente.",
      ticketLabel: "Ticket #:",
      pay: "Pagar",
      noAvailablePlays: "No hay jugadas disponibles.",
    },
    success: {
      cancelText: "Aceptar",
      okText: "Ver/Imprimir Ticket",
    },
  },
  404: {
    code: "404",
    title: "Página no encontrada",
    goToHome: "ir a inicio",
  },
  accountVerification: {
    title: "Verificación de cuenta",
    success: "verificación de correo electrónico exitosa",
    error: "Ocurrio un error al verificar la cuenta.",
    goToHome: "ir a inicio",
    goToLogin: "Acceder a mi cuenta",
    invalidToken: "Token de verificación inválido.",
    verifying: "Verificando...",
  },
  orders: {
    title: "Tickets de jugadas",
    singular: "Ticket de jugada",
    placeholderSearch: "Buscar",
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        code: {
          label: "Número de ticket",
          placeholder: "Introduce el número de ticket.",
        },
        status: {
          label: "Estado",
          placeholder: "Selecciona el estado.",
          cancelled: "Cancelado",
          processed: "Procesado",
        },
        user: {
          label: "Cliente",
          placeholder: "Selecciona el cliente.",
        },
      },
    },
    table: {
      emptyText: "No hay tickets de jugadas.",
      columns: {
        codeNumber: "Número de ticket",
        code: "Número",
        date: "Fecha",
        user: "Cliente",
        totalAmount: "Monto total",
        wonTotalAmount: "Monto ganado",
        paid: "Pagado",
        status: {
          title: "Estado",
          processed: "Procesado",
          cancelled: "Cancelado",
        },
        action: {
          title: "Acción",
          view: "Ver",
          cancel: "Cancelar",
        },
      },
    },
    view: {
      loading: "Cargando...",
      goBack: "Volver",
      title: "Ticket",
      subtitle: "Detalle de ticket",
      loadingText: "Cargando...",
      playDetails: "DETALLES DE TICKET #",
      guaranteePayment: "Garantia de pago",
      dateLabel: "Fecha: ",
      phoneLabel: "Tel: ",
      ticketNoLabel: "Ticket #: ",
      totalLabel: "Total",
      discountAmountLabel: "Descuento",
      subtotalLabel: "Subtotal",
      wonTotalLabel: "Ganado",
      checkTicketLabel: "Revise su ticket",
      noPaymentLabel: "No pagamos sin ticket",
      promotionLabel: "Promoción: ",
      sellerLabel: "Vendedor",
      clientLabel: "Cliente",
      print: "Imprimir",
      cancel: "Cancelar",
      playTypes: {
        quiniela: "Quiniela",
        pale: "Pale",
        tripleta: "Tripleta",
        superpale: "Super pale",
        superquiniela: "Super quiniela",
        chance: "Chance",
        doble_chance: "Doble Chance",
        triple_chance: "Triple Chance",
        superquinielaDescription:
          "Haga clic para ver los detalles de la jugada",
      },
      cancelConfirmation: {
        title: "Cancelar ticket",
        content: "Favor de confirmar que desea cancelar el ticket #{code}.",
        note: "Notas:",
        note1:
          "No se permite la cancelacion de tickets que contengan loterias cerradas.",
        note2:
          "No se permite la cancelacion de tickets pasado {count} minutos luego de su compra.",
        okText: "Sí, cancelar",
        cancelText: "Cerrar",
        errorCancellation: "Ocurrio un error al cancelar el ticket.",
        successCancellation: "Ticket cancelado exitosamente.",
        cancelLabel: "Cancelar",
      },
      cancelledBy: {
        admin: "Admin: ",
        user: "Usuario: ",
        date: "Cancelado el: ",
      },
      statuses: {
        label: "Estado: ",
        cancelled: "Cancelado",
        processed: "Procesado",
      },
      table: {
        type: "Tipo Jugada/Loterías",
        typeShort: "PR",
        numbers: "Números",
        lottery: "Loterias",
        amount: "Valor",
        wonAmount: "Ganado",
      },
      rafflesTable: {
        lottery: "Lotería",
        firstPrize: "Primera",
        secondPrize: "Segunda",
        thirdPrize: "Tercera",
        fourthPrize: "Cuarta",
        fifthPrize: "Quinta",
      },
    },
    userCashBalanceReport: {
      title: "Reporte de cuadre",
      subtitle: "Reporte de cuadre de balance",
      error: "Error al generar el reporte de cuadre.",
      table: {
        emptyTextNoData: "No se encontraron datos para la fecha seleccionada.",
        emptyText: "Generar reporte para ver los datos.",
        generate: "Generar reporte",
        total: "Total",
        totalWon: "Total Premios",
        info: "Información",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
          required: "Rango de fechas requerido.",
        },
        columns: {
          date: "Fecha",
          totalAmount: "Subtotal Venta",
          wonTotalAmount: "Total Premios",
        },
      },
    },
  },
  systemConfig: {
    title: "Configuración del sistema",
    tabs: {
      smtpConfig: {
        title: "Configuración de SMTP",
        testEmailSuccessMessage:
          "Correo de prueba enviado exitosamente a {email}.",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          test: "Enviar correo de prueba",
          host: {
            label: "Host",
            placeholder: "Ex.: smtp.gmail.com",
          },
          port: {
            label: "Puerto",
            placeholder: "Ex.: 587",
          },
          encryption: {
            label: "Tipo de encriptación",
            placeholder: "Ex.: tls",
          },
          user: {
            label: "Usuario",
            placeholder: "Ex.: someone@domain.ext",
          },
          password: {
            label: "Contraseña",
            placeholder: "Ex.: ********",
          },
          toAddress: {
            label: "Enviar correo de prueba a",
            placeholder: "Ex.: someone@domain.ext",
            required:
              "La dirección de correo electrónico es requerida para enviar el correo de prueba.",
          },
        },
        confirmTestEmail: {
          title: "Confirmar",
          subtitle:
            "Favor de confirmar que desea enviar un correo de prueba a la dirección proporcionada.",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          testEmailSuccess: "Correo de prueba enviado exitosamente.",
          testEmailError: "Ocurrio un error al enviar el correo de prueba.",
        },
      },
      craueConfig: {
        title: "Variables globales",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          name: {
            label: "Nombre",
          },
          value: {
            label: "Valor",
            placeholder: "Ex.: numero|texto|json",
          },
          hourRange: {
            label: "Rango de horas",
            placeholder: {
              start: "00:00:00",
              end: "23:59:59",
            },
          },
          description: {
            label: "Descripción",
            placeholder: "Escribe una descripción",
            edit: "Editar",
            save: "Guardar",
          },
        },
      },
      termAndPolicy: {
        title: "Políticas, términos y condiciones",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
        },
      },
      frequentQuestionsPageClient: {
        title: "Preguntas frecuentes",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          add: "Agregar",
          delete: "Eliminar",
          question: "Pregunta",
          answer: "Respuesta",
          link: "Enlace",
        },
      },
      carouselHomePageClient: {
        title: "Carrusel página inicio",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          add: "Agregar",
          cancel: "Cancelar",
          addModalTitle: "Agregar diapositiva",
          title: {
            label: "Título",
            placeholder: "Título",
          },
          link: {
            label: "Enlace",
            placeholder: "Introduce un enlace",
          },
          imageURL: {
            label: "URL de la imagen",
            placeholder: "Introduce una URL",
          },
          status: {
            label: "Estado",
            activeLabel: "Activo",
            inactiveLabel: "Inactivo",
          },
        },
        table: {
          emptyText: "El carrusel no contiene diapositivas.",
          columns: {
            title: "Título",
            link: "Enlace",
            imageURL: "Imagen URL",
            status: "Estado",
            actions: {
              title: "Acciones",
              edit: "Editar",
              delete: "Eliminar",
            },
          },
        },
      },
      creditCardPaymentClients: {
        title: "Clientes tarjeta de crédito",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          add: "Agregar",
          cancel: "Cancelar",
          addModalTitle: "Agregar cliente",
          url: {
            label: "URL",
            placeholder: "Dirección URL del cliente.",
          },
          percentage: {
            label: "Percentage",
            placeholder: "Introduce el porcentaje.",
          },
        },
        table: {
          emptyText: "No hay clientes de tarjeta de crédito.",
          columns: {
            url: "URL",
            percentage: "Porcentaje",
            actions: {
              title: "Acciones",
              edit: "Editar",
              delete: "Eliminar",
            },
          },
        },
      },
      depositAccounts: {
        title: "Cuentas de depósito",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
          add: "Agregar",
          cancel: "Cancelar",
          addModalTitle: "Agregar cuenta",
          account: {
            label: "Cuenta",
            placeholder: "Formatear cuenta aqui...",
          },
        },
        card: {
          emptyText: "No hay cuentas de depósito registradas.",
          actions: {
            delete: "Eliminar",
            edit: "Editar",
          },
        },
      },
      welcomePage: {
        title: "Página de bienvenida",
        form: {
          loading: "Cargando configuración...",
          save: "Guardar",
        },
      },
    },
  },
  commissions: {
    title: "Reporte de comisiones",
    subtitle: "Generar y pagar reporte de comisiones",
    payGeneratedSucessfully: "Pagos de comisiones efectuados exitosamente.",
    errorGeneratingPay: "Ocurrio un error al generar los pagos de comisiones.",
    noSelectionError: "Debe seleccionar al menos una comisión.",
    confirm: {
      title: "Confirmar",
      subtitle:
        "Favor de confirmar que desea generar el pago del reporte de comisiones.",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    },
    form: {
      date: {
        label: "Mes/Año",
        placeholder: "Selecciona un mes/año",
      },
      user: {
        label: "Vendedor",
        placeholder: "Selecciona un vendedor",
      },
      action: {
        generate: "Generar",
        pay: "Pagar",
        goBack: "Volver",
      },
    },
    table: {
      columns: {
        date: "Fecha",
        user: "Vendedor",
        month: "Mes",
        year: "Año",
        total: "Total",
        percentage: "Porcentaje",
        amount: "Monto",
        paid: "Pagado",
        paidAt: "Fecha de pago",
        createdBy: "Pagado por",
        type: {
          title: "Tipo",
          AFFILIATE_NETWORK_COMMISSION: "Red afiliados",
          REFERRAL_COMMISSION: "Referidos",
          SELLER_COMMISSION: "Ventas",
        },
      },
      summary: {
        total: "Total",
        totalPaid: "Total Pagado",
        totalPending: "Total Pendiente",
        averageCommissionPercentage: "Promedio % de comisiónes",
        totalCommissions: "Total comisiónes",
        totals: "TOTALES",
      },
      emptyText: "No hay comisiones para mes {date}.",
      loading: "Cargando report comisiones...",
    },
  },
  transactionList: {
    title: "Lista de transacciones",
    subtitle: "Listado de transacciones realizadas",
    placeholderSearch: "Buscar por número.",
    newTransaction: "Nueva transacción",
    table: {
      emptyText: "No se encontraron transacciones.",
      columns: {
        date: "Fecha",
        code: "Número",
        type: "Tipo",
        origin: "Origen",
        amount: "Monto",
        status: {
          title: "Estado",
          pending: "Pendiente",
          cancelled: "Cancelado",
          rejected: "Rechazado",
          success: "Procesada",
          approval_pending: "En Revisión",
          in_refund: "En Devolución",
          refunded: "Devolucionado",
        },
        action: {
          title: "Acciones",
          view: "Ver",
          reject: "Rechazar",
          delete: "Eliminar",
          cancel: "Cancelar",
          moreInfo: "Más info.",
        },
        transactions: "Transacciones",
      },
    },
    confirmCancellation: {
      title: "Cancelar transacción",
      content: "Favor de confirmar que desea cancelar la transacción #{code}.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
    },
    cancelTransferSuccess: "Transacción cancelada exitosamente.",
    cancelTransferError: "Ocurrio un error al cancelar la transacción.",
    withdrawCancellationInProgress: "En proceso de cancelación.",
    confirmRequestWithdrawCancellation: {
      title: "Solicitar cancelar retiro",
      content:
        "Favor de confirmar que desea solicitar la cancelación del retiro #{code}.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
    },
    requestCancelWithdrawSuccess:
      "Solicitud de cancelación registrada exitosamente.",
    requestCancelWithdrawError:
      "Ocurrio un error al solicitar la cancelación del retiro.",
    requestWithdrawCancellationAlert: {
      title: "Solicitud de cancelación de retiro",
      description:
        "Su solicitud de retiro esta en proceso de cancelación, este proceso se toma unos minutos ya que requiere de la intervención de un supervisor.",
    },
    moreInfo: {
      title: "Información de transacción {code}",
      date: "Fecha",
      code: "Número",
      reference: "Ticket/Referencia",
      type: "Tipo",
      origin: "Origen",
      amount: "Monto",
      status: "Estado",
    },
  },
  transactionView: {
    title: "Transacción",
    refundDetailsTitle: "Detalles de la Devolución",
    refundReasonLabel: "Motivo: ",
    refundBankLabel: "Banco Destino: ",
    refundAccountLabel: "Cuenta Destino: ",
    refundIdCardLabel: "Cédula: ",
    refundReferenceLabel: "Referencia: ",
    refundProcessedAtLabel: "Fecha de Devolución: ",
    refundVoucherLabel: "Comprobante de Devolución",
    refundInProcessAlertTitle: "Depósito en proceso de devolución",
    refundInProcessAlertDesc:
      "Este depósito no pudo ser aprobado y se encuentra actualmente en proceso de devolución a su cuenta bancaria.",
    refundedAlertTitle: "Depósito devuelto",
    refundedAlertDesc:
      "Este depósito ha sido devuelto a su cuenta bancaria. A continuación puede consultar los datos del reembolso.",
    subtitle: "Detalle de transacción",
    loadingText: "Cargando...",
    transactionDetails: "DETALLES DE TRANSACCIÓN #",
    dateLabel: "Fecha: ",
    phoneHolderLabel: "Tel: ",
    transactionNoLabel: "Transacción #: ",
    amountLabel: "Monto: ",
    sellerLabel: "Vendedor: ",
    clientLabel: "Cliente: ",
    print: "Imprimir: ",
    phoneLabel: "Teléfono: ",
    typeLabel: "Tipo: ",
    originLabel: "Origen: ",
    currencyLabel: "Moneda: ",
    bankLabel: "Banco: ",
    accountLabel: "Cuenta: ",
    accountTypeLabel: "Tipo de cuenta: ",
    accountHolderLabel: "Titular de la cuenta: ",
    identificationCardLabel: "Cédula: ",
    emailHolderLabel: "Correo electrónico: ",
    commentLabel: "Comentario: ",
    referenceLabel: "Referencia: ",
    vouchersLabel: "Comprobantes",
    statusLabel: "Estado: ",
    phoneHolder: "Teléfono: ",
    destinationPhoneLabel: "Teléfono/Celular Dest.: ",
    destinationUserLabel: "Nombre destinatario: ",
    voucherLoadError: "Ocurrio un error al cargar el comprobante.",
    confirmCancellation: {
      title: "Cancelar transacción",
      content: "Favor de confirmar que desea cancelar la transacción #{code}.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
    },
    cancelTransferSuccess: "Transacción cancelada exitosamente.",
    cancelTransferError: "Ocurrio un error al cancelar la transacción.",
    withdrawCancellationInProgress: "En proceso de cancelación.",
    confirmRequestWithdrawCancellation: {
      title: "Solicitar cancelar retiro",
      content:
        "Favor de confirmar que desea solicitar la cancelación del retiro #{code}.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
    },
    requestCancelWithdrawSuccess:
      "Solicitud de cancelación registrada exitosamente.",
    requestCancelWithdrawError:
      "Ocurrio un error al solicitar la cancelación del retiro.",
    requestWithdrawCancellationAlert: {
      title: "Solicitud de cancelación de retiro",
      description:
        "Su solicitud de retiro esta en proceso de cancelación, este proceso se toma unos minutos ya que requiere de la intervención de un supervisor.",
    },
  },
  profile: {
    birthdate: "Fecha de nacimiento",
    verifyIdentity: {
      title: "Verificación de identidad",
      verified: "Identidad verificada",
      unverified: "Identidad no verificada",
      verifyButton: "Verificar identidad",
      identityVerification: "Verificación de identidad",
      underReview: "En revisión",
      form: {
        upload: "Subir identificación",
        errorsTitle: "Errores de verificación",
        description:
          "Por favor, sube una copia clara de tu documento de identidad y una selfie sosteniendo el documento. Para que el proceso de verificación sea exitoso, los datos deben coincidir con los de la cuenta.",
        dfp: {
          label: "Cédula/Licencia/DNI (Frontal)",
          placeholder: "Subir documento frontal",
          required: "El documento frontal es requerido.",
        },
        dbp: {
          label: "Cédula/Licencia/DNI (Posterior)",
          placeholder: "Subir documento posterior",
          required: "El documento posterior es requerido.",
        },
        selfie: {
          label: "Selfie con el documento",
          placeholder: "Subir selfie con el documento",
          required: "La selfie con el documento es requerida.",
        },
        submit: "Enviar para verificación",
        success:
          "Documentos enviados para verificación. Nos pondremos en contacto contigo pronto.",
        error: "Ocurrio un error al enviar los documentos para verificación.",
      },
    },
  },
  transactionForm: {
    title: "Solicitud de",
    subtitle: "Solicitud de transacción",
    submittingText: "Enviando solicitud...",
    transactionInfoLabel: "Información de transacción",
    paymentMethodInfoLabel: "Método de pago",
    withdrawMethodInfoLabel: "Método de retiro",
    bankInfoLabel: "Información Bancaria",
    vouchersLabel: "Comprobantes",
    holderInfoLabel: "Información del titular",
    accountNotFound: "Cuenta no encontrada.",
    pay: "Procesar Pago",
    formError: "Error en el formulario.",
    accountNotFoundDescription:
      "No existe una cuenta con el número especificado.",
    infoLabel:
      '<ul class="work-day"><li>Lunes a Sábados: 9:00am a 10:00pm.</li><li>Domingo: 9:00am a 7:00pm.</li></ul><p class="note"><strong>Nota:</strong><br /><span>- Solo se permiten dos retiros por dia.</span>{{more}}</p>',
    depositCommissionInfoLabel:
      "<span>- Recarga y aplicaremos a tu balance un {{variable}}% del monto del recargado.</span><br />",
    depositInfoLabel:
      '<ul class="work-day"><li>Lunes a Domingos: 9:00am a 10:00pm.</li></ul><p class="note"><strong>Nota:</strong><span>{{deposit}}<span>- Las recargas aplicadas, deben ser consumidas dentro de la plataforma, no procesamos devoluciones.</span></span></p>',
    isCreditCardEnabledMessage: `Para habilitar los pagos con tarjeta de credito debe hacer nuestro proceso de verificacion, por favor escribir a nuestro whatsapp: <b>{{numero}}</b> para continuar con el proceso. {{clickhere}}`,
    whatsappMessage2: "Quiero habilitar los pagos con tarjeta de credito.",
    clickhere:
      "<a href='https://wa.link/9ukmq9' target='_blank'>Haz clic aquí.</a>",
    withdrawInfoLabel: "Balance disponible para retiro",
    promotionAvailableLabel:
      "¡Tienes una promoción activa! Recibirás un {{value}}% extra en tu próximo depósito.",
    currency: {
      label: "Moneda",
      placeholder: "Selecciona la moneda.",
      DOP: "Pesos Dominicanos (DOP)",
      USD: "Dólares Americanos (USD)",
      BTC: "Bitcoin (BTC)",
    },
    origin: {
      label: "Tipo",
      placeholder: "Selecciona el tipo.",
      TRANSFER: "Transferencia",
      PLISIO: "Plisio",
      CRYPTO: "Criptomonedas (USDT)",
    },
    type: {
      label: "Tipo",
      placeholder: "Método de pago.",
      DEPOSIT: "Depósito",
      WITHDRAW: "Retiro",
      TRANSFER: "Transferencia",
      BANK_TRANSFER: "Transferencia bancaria",
      TETHER: "Tether (USDT)",
      CREDIT_CARD: "Tarjeta de crédito",
      CRYPTO: "Crypto",
      PAYKASAMA: "Banreservas",
    },
    amount: {
      label: "Monto",
      placeholder: "0.00",
    },
    accountType: {
      label: "Tipo de cuenta",
      placeholder: "Selecciona el tipo de cuenta.",
      SAVINGS: "Ahorros",
      CHECKING: "Corriente",
    },
    bank: {
      label: "Banco",
      placeholder: "Banco",
    },
    account: {
      label: "Cuenta",
      placeholder: "Cuenta",
      labelPaypal: "Email PayPal",
      placeholderPaypal: "Introduce el email de PayPal.",
      labelZelle: "Número Teléfono",
      placeholderZelle: "Introduce el número de teléfono.",
      labelCashApp: "Número Teléfono",
      placeholderCashApp: "Introduce el número de teléfono.",
    },
    accountHolder: {
      label: "Titular de la cuenta",
      placeholder: "Titular de la cuenta",
    },
    identificationCard: {
      label: "Cédula",
      placeholder: "Cédula",
    },
    phoneHolder: {
      label: "Teléfono",
      placeholder: "Teléfono",
    },
    emailHolder: {
      label: "Correo electrónico",
      placeholder: "Correo electrónico",
    },
    comment: {
      label: "Comentario",
      placeholder: "Comentario",
    },
    voucher: {
      label: "Comprobante",
      placeholder: "Comprobante",
      required: "Debe subir un comprobante.",
    },
    password: {
      label: "Contraseña",
      placeholder: "Escriba su contraseña",
      required: "La contraseña es requerida.",
    },
    reference: {
      label: "Referencia",
      placeholder: "Referencia",
    },
    destinationAccountPhone: {
      label: "Teléfono/Celular",
      placeholder: "(000) 000-0000",
    },
    destinationUser: {
      label: "Nombre destinatario",
      placeholder: "Selecciona el usuario destino.",
    },
    depositTips: [
      "Consulta los datos bancarios para realizar tu depósito haciendo click <b>{{link}}</b>.",
      "Realiza la transferencia del monto deseado y toma una captura de pantalla del comprobante de la transacción.",
      "Carga la captura de pantalla a través del boton que se presenta más abajo para que el saldo sea acreditado en tu cuenta o lo puede envia a nuestros numeros de whatsapp: {{whatsapp}}.",
    ],
    tetherTips: {
      description:
        "Compra cripto al instante y transfiérelas automáticamente a tu saldo de <strong>TujugadaRD</strong>. ¡Simplemente selecciona a continuación la cantidad y la billetera en la que deseas depositarlo!",
      linkLabel: "Haz clic aqui.",
    },
    creditCardClientTips: {
      btnPayment: "Procesar pago",
      error: "Ocurrio un error al obtener el cliente de pago.",
      success: "Depósito procesado exitosamente.",
      cancelled: "Depósito cancelado exitosamente.",
      successTitle: "Depósito procesado",
      cancelledTitle: "Depósito cancelado",
      requiredAmount: "Debe ingresar un monto.",
      minAmount: "El monto mínimo es de {min}.",
      okText: "Aceptar",
      process: {
        title: "Procesar pago",
        redirecting: "Redireccionando a la pasarela de pago...",
        description:
          '¡Nuestros pagos con tarjeta de crédito y débito son seguros, instantáneos y discretos!. Serás redirigido a nuestra pasarela de pago segura después de hacer clic en "Realizar pedido".',
        btnProcess: "Realizar pedido",
      },
      amount: "Monto",
      fee: "Comisión",
      total: "Total",
    },
    save: {
      label: "¿Adicionar a mis cuentas?",
    },
    selectAccountError: "Debe seleccionar o agregar una cuenta.",
    bankAccountInfoLabel: "Información de la cuenta",
    bankAndAccountTypeLabel: "Banco y tipo de cuenta:",
    bankAccountNumberLabel: "Número de cuenta:",
    identificationCardLabel: "Cédula:",
    confirmButtonText: "Confirmar",
    saveAccountButtonText: "Guardar cuenta",
    deleteAccountTitle: "Eliminar cuenta",
    deleteAccountContent: "¿Estás seguro que deseas eliminar esta cuenta?",
    deleteAccountOkText: "Sí, eliminar",
    deleteAccountCancelText: "Cancelar",
    whatsappMessage: "Quiero hacer un depósito.",
    submit: "Enviar solicitud",
    success: "Solicitud enviada exitosamente.",
    transferSuccess: "Transferencia realizada exitosamente.",
    error: "Ocurrio un error al enviar la solicitud.",
    copiedToClipboard: "Copiado al portapapeles",
    tetherDirTitle: "Tu Dirección Tether",
    copyToClipboard: "Copiar Dirección Tether (USDT)",
    loadingQRCode: "Cargando código QR...",
    btnAmounts: [300, 500, 1000, 2500],
    confirmPolicy: {
      title: "¡Información importante!",
      content:
        "En el comprobante de deposito o transferencia debe colocar SOLAMENTE su nombre y apellido. Esto con fines de acelerar el proceso de confirmación y agilizar su recarga.",
      okText: "De acuerdo",
      cancelText: "Cancelar",
    },
    transfer: {
      title: "Detalles",
      amount: "Monto",
      charges: "Cargo",
      total: "Total",
    },
    confirmPassword: {
      title: "Confirmar datos para enviar solicitud",
      subtitle:
        "Favor escriba su contraseña de usuario para confirmar la transferencia de balance",
      confirmButtonText: "Enviar",
      cancelButtonText: "Cancelar",
    },
    transferWithdrawBalance: {
      btnTransfer: "Transferir balance a depósito",
      info: "El balance disponible para retiro se transferirá a depósito para ser consumido en la plataforma y se generaran comisiones por depósito, tal como se generan en un depósito normales.",
      title: "¿Seguro que desea transferir su balance a depósito?",
      subtitle:
        "Se generaran comisiones por depósito, tal como se generan en un depósito normal.",
      confirmButtonText: "Transferir",
      cancelButtonText: "Cancelar",
      success: "Balance transferido exitosamente.",
      error: "Ocurrio un error al transferir el balance.",
      requiredAmount: "Debe ingresar un monto.",
      minAmount: "El monto mínimo es de {min}.",
    },
  },
  whatsappWidget: {
    title: "WhatsApp",
    subtitle: "Click para escribirnos",
    error: "No se ha configurado el número de WhatsApp",
  },
  buy: {
    title: "Comprar ticket",
    subtitle: "Comprar ticket",
    ticketList: "Lista de jugadas",
    lotteryCLoseTimeLabel: (value) => `Sorteo cierra a las ${value}.`,
    payError: "Ocurrio un error al pagar el ticket.",
    mixPaleError: "Ocurrión un error al intentar crear los Pale",
    mixTripletaError: "Ocurrión un error al intentar crear las Tripletas",
    mixPaleTripletaError:
      "Ocurrión un error al intentar crear los Pale y las Tripletas",
    sharedError: "Ocurrio un error al leer el ticket compartido.",
    insufficientBalance:
      "Usted no tiene suficiente saldo para pagar el ticket.",
    nonRepeated2Pools: "Debes tener almenos dos Quinielas no repetidas",
    nonRepeated3Pools: "Debes tener almenos tres Quinielas no repetidas",
    stats: {
      button: "Ver estadísticas",
      title: "Estadísticas",
      subtitle: "Lotería",
      loading: "Cargando estadísticas...",
      hotNumbers: "Calientes",
      coldNumbers: "Fríos",
      noData: "No hay datos para mostrar.",
      confirmPlay: {
        amount: {
          label: "Monto",
          placeholder: "0",
          validation: "El monto es requerido y debe ser mayor a 0.",
        },
        lotteries: {
          label: "Loterías",
          placeholder: "Seleccione una o más loterías.",
          validation: "Debe seleccionar al menos una lotería.",
        },
        title: "Confirmar jugada",
        subtitle:
          "Favor seleccione el monto y la(s) lotería(s) en las cuales desea agregar el número <b>{numbers}</b>.",
        okText: "Sí, agregar",
        cancelText: "Cerrar",
      },
    },
    autoticket: {
      amount: "Monto",
      setAmount: "Introduce el monto",
      autoGenerate: "Generar automáticamente",
      auto: "Autoticket",
    },
    form: {
      title: "Comprar ticket",
      addPlays: "Agregar jugadas",
      otherPlays: "Otras jugadas disponibles",
      selectMatch: "Seleccione el tipo de acierto",
      setSelectMatch: "Debe seleccionar almenos un acierto",
      mixTitle: "Mezcador de jugadas",
      addMixes: "Agregar combinaciones",
      cleanMixes: "Limpiar combinaciones",
      mixesTitle: "Combinaciones",
      mixesQuinielas: "Quinielas",
      mixesPales: "Pales",
      mixesSuperpales: "Superpales",
      mixesSuperquinielas: "Superquinielas",
      mixesTripletas: "Tripletas",
      loading: "Cargando...",
      clear: "Eliminar jugadas",
      clearError: "Aun no ha agregado jugadas al carrito.",
      deleteMix: "Eliminar combinación",
      pay: "Pagar ticket",
      noPlay: "Sin jugada",
      playTypes: {
        title: "Tipo de jugada",
        quiniela: "Quiniela",
        pale: "Pale",
        superpale: "Super pale",
        superquiniela: "Super quiniela",
        chance: "Chance",
        doble_chance: "Doble Chance",
        triple_chance: "Triple Chance",
        tripleta: "Tripleta",
        auto: "Auto",
        pick3: "Pick 3",
        pick4: "Pick 4",
        superquinielaDescription:
          "Haga clic para ver los detalles de la jugada",
        superPaleWarning:
          "Debe seleccionar al menos dos loterías para jugar super pale.",
      },
      matchesPick: {
        straight: "Straight",
        box: "Box",
      },
      date: {
        label: "Fecha",
        placeholder: "--/--/----",
      },
      isSuperpale: {
        label: "Es super pale?",
      },
      mix: {
        label: "Mezclador de jugadas?",
      },
      lotteries: {
        label: "Loterias",
        placeholder: "Seleccione una o más loterias.",
        required: "Debe seleccionar al menos una loteria.",
        min: (min) => `Debe seleccionar al menos ${min} loteria(s).`,
        timeLeft: "Tiempo restante para cierre de lotería",
        outOfTime:
          "Algunas de las loterías en el enlace está fuera de horario.",
        superquiniela_not_enabled:
          "La lotería seleccionada no está habilitada para super quiniela.",
        superquiniela_not_enabled_desc:
          "La jugada con el numero {numbers} de la loteria {lottery} no será agregada porque no está habilitada para super quiniela.",
      },
      superPale: {
        label: "Super pale",
        placeholder: "00-00",
      },
      numbers: {
        label: "Números",
        placeholder: "00-00-00",
        placeholderQuiniela: "00",
        placeholderSuperquiniela: "00",
        placeholderPale: "00-00",
        placeholderPick3: "0-0-0",
        placeholderPick4: "0-0-0-0",
      },
      number: {
        label: "Números a Mezclar",
        placeholder: "00",
      },
      amount: {
        label: "Monto",
        placeholder: "0",
      },
      quinielaAmount: {
        label: "Quiniela",
        placeholder: "$ 0",
      },
      paleAmount: {
        label: "Pale",
        placeholder: "$ 0",
      },
      superpaleAmount: {
        label: "Superpale",
        placeholder: "$ 0",
      },
      superquinielaAmount: {
        label: "Superquiniela",
        placeholder: "$ 0",
      },
      tripletaAmount: {
        label: "Tripleta",
        placeholder: "$ 0",
      },
      add: "Agregar",
    },
    table: {
      total: "Total",
      play: "Lotería / Lotto / Jugada",
      type: "Tipo de jugada",
      lottery: "Loteria",
      numbers: "Números",
      amount: "Monto",
      action: {
        title: "Acción",
        remove: "Eliminar Jugada",
      },
    },
    payment: {
      title: "Revisa tu ticket",
      payTicket: "Pagar Ticket",
      totalTicket: "Total:",
      success: "Ticket pagado & generado exitosamente.",
      ticketLabel: "Ticket #:",
      pay: "Pagar",
      noAvailablePlays: "No hay jugadas disponibles.",
    },
    success: {
      cancelText: "Aceptar",
      okText: "Ver/Imprimir Ticket",
    },
    rebuyTicketModal: {
      rebuyTitle: "Juégalo otra vez",
      sharedTitle: "Ticket compartido",
      next: "Siguiente",
      prev: "Anterior",
      cancel: "Cancelar",
      addPlays: "Agregar",
      addPlay: "Agregar jugada",
      form: {
        confirmPlaysAndAdd: "Confirmar jugadas y agregar",
        superpaleError:
          "Debe seleccionar dos loterias o más para el super pale.",
        amountPerPlayType: "Monto por tipo de jugada",
        paleAmount: {
          label: "Pale",
          placeholder: "$ 0",
        },
        superpaleAmount: {
          label: "Super pale",
          placeholder: "$ 0",
        },
        superquinielaAmount: {
          label: "Super quiniela",
          placeholder: "$ 0",
        },
        tripletaAmount: {
          label: "Tripleta",
          placeholder: "$ 0",
        },
        quinielaAmount: {
          label: "Quiniela",
          placeholder: "$ 0",
        },
        lotteries: {
          label: "Selecciona la(s) loteria(s)",
          placeholder: "Selecciona una o más loterias.",
          required: "Debe seleccionar al menos una loteria.",
          min: (min) => `Debe seleccionar al menos ${min} loteria(s).`,
        },
        plays: {
          label: "Lista de jugadas",
        },
      },
    },
  },
  commissionProfiles: {
    title: "Perfiles de comisiones",
    subtitle: "Listado de perfiles de comisiones",
    placeholderSearch: "Buscar por nombre.",
    add: "Añadir",
    deletedSuccess: "Perfil de comisión eliminado exitosamente.",
    deletedError: "Ocurrio un error al eliminar el perfil de comisión.",
    pageTitleViewing: "Viendo perfil de comisión",
    pageTitleCreate: "Crear perfil de comisión",
    confirm: {
      title: "¿Estás seguro que deseas eliminar este perfil de comisión?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        type: {
          label: "Tipo",
          placeholder: "Selecciona el tipo.",
        },
      },
    },
    table: {
      emptyText: "No se encontraron perfiles de comisiones.",
      columns: {
        id: "ID",
        name: "Nombre",
        profile: "Sub Perfil",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        createdAt: "Fecha de creación",
        schemas: "Esquemas",
        benefits: "Beneficios",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Perfil de comisión",
      titleCreate: "Crear perfil de comisión",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteCommissionProfile: "Eliminar",
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      profile: {
        label: "Sub perfil",
        placeholder: "Seleccione un sub perfil.",
      },
      status: {
        label: "Estado",
        placeholder: "Selecciona el estado.",
        active: "Activo",
        inactive: "Inactivo",
      },
      type: {
        label: "Tipos",
        referralCommission: {
          label: "Bono por referido",
          value: "REFERRAL_COMMISSION",
          ruleMinimumAmount: {
            label: "Monto mínimo para aplicar bono",
            placeholder: "0.00",
          },
          amount: {
            label: "Monto bono",
            placeholder: "0.00",
          },
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        affiliateNetworkCommission: {
          label: "Comisión red afiliados",
          value: "AFFILIATE_NETWORK_COMMISSION",
          level1Percentage: {
            label: "Nivel 1",
            placeholder: "% 0",
          },
          level2Percentage: {
            label: "Nivel 2",
            placeholder: "% 0",
          },
          status: {
            label: "Estado",
            placeholder: "Estado de la comisión",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        salesCommissions: {
          label: "Comisión por ventas",
          value: "USER_SALES_COMMISSIONS",
          quantityBlockedNumbers: {
            label: "Cantidad de números bloqueados",
            placeholder: "0",
          },
          employerPercentage: {
            label: "Porcentaje empleador",
            placeholder: "% 0",
          },
          sellerPercentage: {
            label: "Porcentaje vendedor",
            placeholder: "% 0",
          },
          status: {
            label: "Estado",
            placeholder: "Estado de la comisión",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        userDepositCommission: {
          label: "Comisión por depósito",
          value: "USER_DEPOSIT_COMMISSION",
          ruleMinimumAmount: {
            label: "Monto mínimo para aplicar comisión",
            placeholder: "0.00",
          },
          percentage: {
            label: "Porcentaje",
            placeholder: "% 0",
          },
          status: {
            label: "Estado",
            placeholder: "Estado de la comisión",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        userRegistrationBonus: {
          label: "Bono por registro (Referido)",
          value: "USER_REGISTRATION_BONUS",
          amount: {
            label: "Monto bono",
            placeholder: "0.00",
          },
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        userRegistrationBonusClient: {
          label: "Bono por registro (Cliente)",
          value: "USER_REGISTRATION_BONUS_CLIENT",
          amount: {
            label: "Monto bono",
            placeholder: "0.00",
          },
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
      },
      tabs: {
        generalInfo: {
          title: "Información general",
        },
        assignedLotteries: {
          title: "Loterias asignadas",
        },
      },
      assignedLotteries: {
        title: "Loterias asignadas",
        subtitle: "Click en el botón añadir para asignar loterias.",
        add: "Añadir",
        table: {
          emptyText: "No se encontraron loterias asignadas.",
          columns: {
            lottery: "Loteria",
            startDate: "Fecha inicio",
            quinielaFirst: "Quiniela 1ra",
            paleFirst: "Pale 1ra",
            tripletaFirst: "Tripleta 1ra",
            superpaleFirst: "Super pale 1ra",
            superquinielaFirst: "Super quiniela 1ra",
            status: {
              title: "Estado",
              active: "Activo",
              inactive: "Inactivo",
            },
            actions: {
              title: "Acciones",
              edit: "Editar",
              delete: "Eliminar",
              moreInfo: "Más info.",
            },
            assignations: "Asignaciones",
          },
          confirmDelete: {
            title: "¿Estás seguro de eliminar esta asignación?",
            content: "Esta acción no se puede deshacer.",
            okText: "Sí, eliminar",
            cancelText: "Cerrar",
            error: "Ocurrio un error al eliminar la asignación.",
            success: "Asignación eliminada exitosamente.",
          },
        },
        moreInfo: {
          title: "Información de loteria {name}",
          startDate: "Fecha inicio",
          status: "Estado",
          prizes: "Premios",
          quinielaFirst: "Quiniela 1ra",
          quinielaSecond: "Quiniela 2da",
          quinielaThird: "Quiniela 3ra",
          paleFirst: "Pale 1ra",
          paleSecond: "Pale 2da",
          tripletaFirst: "Tripleta 1ra",
          tripletaSecond: "Tripleta 2da",
          superpaleFirst: "Super pale 1ra",
          superquinielaFirst: "Super quiniela 1ra",
          pick3Straight: "Pick 3 Straight",
          pick3Box: "Pick 3 Box",
          pick4Straight: "Pick 4 Straight",
          pick4Box: "Pick 4 Box",
        },
        modal: {
          edit: "Editando asignación de loteria",
          add: "Añadir asignación de loteria",
          okText: "Agregar",
          updateText: "Actualizar",
          cancelText: "Cancelar",
        },
        form: {
          rewards: "Premios",
          status: "Activar/Desactivar",
          first: {
            label: "Primera",
            placeholder: "0.00",
          },
          second: {
            label: "Segunda",
            placeholder: "0.00",
          },
          third: {
            label: "Tercera",
            placeholder: "0.00",
          },
          straight: {
            label: "Straight",
            placeholder: "0.00",
          },
          box: {
            label: "Box",
            placeholder: "0.00",
          },
          quiniela: "Quiniela",
          pale: "Pale",
          tripleta: "Tripleta",
          superpale: "Super pale",
          pick3: "Pick 3",
          pick4: "Pick 4",
          superquiniela: "Super quiniela",
          lotteries: {
            label: "Loterias",
            placeholder: "Selecciona la loteria.",
            selectAll: "Seleccionar todas",
          },
          startDate: {
            label: "Fecha inicio",
            placeholder: "DD/MM/YYYY HH:MM:SS",
          },
          quinielaFirst: {
            label: "Quiniela 1ra",
            placeholder: "00-99",
          },
          quinielaSecond: {
            label: "Quiniela 2da",
            placeholder: "00-99",
          },
          quinielaThird: {
            label: "Quiniela 3ra",
            placeholder: "00-99",
          },
          paleFirst: {
            label: "Pale 1ra",
            placeholder: "00-99",
          },
          paleSecond: {
            label: "Pale 2da",
            placeholder: "00-99",
          },
          tripletaFirst: {
            label: "Tripleta 1ra",
            placeholder: "00-99",
          },
          tripletaSecond: {
            label: "Tripleta 2da",
            placeholder: "00-99",
          },
          superpaleFirst: {
            label: "Super pale 1ra",
            placeholder: "00-99",
          },
          superquinielaFirst: {
            label: "Super quiniela 1ra",
            placeholder: "00-99",
          },
        },
      },
    },
  },
  transactionProfiles: {
    title: "Perfiles de transacciones",
    subtitle: "Listado de perfiles de transacciones",
    placeholderSearch: "Buscar por nombre.",
    add: "Añadir",
    deletedSuccess: "Perfil de transacción eliminado exitosamente.",
    deletedError: "Ocurrio un error al eliminar el perfil de transacción.",
    pageTitleViewing: "Viendo perfil de transacción",
    pageTitleCreate: "Crear perfil de transacción",
    confirm: {
      title: "¿Estás seguro que deseas eliminar este perfil de transacción?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        type: {
          label: "Tipo",
          placeholder: "Selecciona el tipo.",
        },
      },
    },
    table: {
      emptyText: "No se encontraron perfiles de transacciones.",
      columns: {
        id: "ID",
        name: "Nombre",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        createdAt: "Fecha de creación",
        schemas: "Reglas",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    form: {
      title: "Información de",
      titleView: "Perfil de transacción",
      titleCreate: "Crear perfil de transacción",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteTransactionProfile: "Eliminar",
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      status: {
        label: "Estado",
        placeholder: "Selecciona el estado.",
        active: "Activo",
        inactive: "Inactivo",
      },
      confirm: {
        title: "Seleccione un tipo de esqueleto para continuar.",
        cancelText: "Cancelar",
        okText: "Aceptar",
        label: "Tipo",
        placeholder: "Selecciona el tipo.",
        error: "Debe seleccionar un tipo.",
      },
      type: {
        label: "Tipos",
        description: "Agregar reglas para el perfil de transacción.",
        transactionQuantityLimit: {
          label: "Límite de cantidad por intervalo de tiempo",
          value: "transaction_quantity_limit",
          interval: {
            label: "Intervalo",
            placeholder: "Selecciona el intervalo.",
            minutes: "Minuto",
            hours: "Hora",
            days: "Día",
            weeks: "Semana",
            months: "Mes",
          },
          quantity: {
            label: "Cantidad",
            placeholder: "0",
          },
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        transactionAmountLimit: {
          label: "Límite de monto por intervalo de tiempo",
          value: "transaction_amount_limit",
          interval: {
            label: "Intervalo",
            placeholder: "Selecciona el intervalo.",
            minutes: "Minuto",
            hours: "Hora",
            days: "Día",
            weeks: "Semana",
            months: "Mes",
          },
          amount: {
            label: "Monto",
            placeholder: "0.00",
          },
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
        },
        lotteryPlayLimitAmounts: {
          label: "Límite de montos por tipo jugadas",
          value: "lottery_play_limit_amounts",
          status: {
            label: "Estado",
            placeholder: "Estado del bono",
            active: "Habilitado",
            inactive: "Deshabilitado",
          },
          quinielaMaxAmount: {
            label: "Quiniela",
            placeholder: "0.00",
          },
          paleMaxAmount: {
            label: "Pale",
            placeholder: "0.00",
          },
          tripletaMaxAmount: {
            label: "Tripleta",
            placeholder: "0.00",
          },
          superpaleMaxAmount: {
            label: "Super pale",
            placeholder: "0.00",
          },
          superquinielaMaxAmount: {
            label: "Super quiniela",
            placeholder: "0.00",
          },
        },
      },
    },
  },
  userbalancemovementList: {
    title: "Movimientos de saldo",
    subtitle: "Listado de movimientos de saldo",
    placeholderSearch: "Buscar por número, tipo, referencia o descripción.",
    regularization: "Regularización",
    table: {
      emptyText: "No se encontraron movimientos de saldo.",
      columns: {
        date: "Fecha",
        number: "Número",
        user: "Cliente",
        reference: "Referencia",
        debit: "Débito",
        credit: "Crédito",
        balance: "Balance",
        description: "Descripción",
        type: {
          title: "Tipo",
          DEBIT: "Débito",
          CREDIT: "Crédito",
        },
        movements: "Movimientos",
      },
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        cancel: "Cancelar",
        save: "Aplicar",
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
        type: {
          label: "Tipo",
          placeholder: "Selecciona el tipo.",
          debit: "Débito",
          credit: "Crédito",
        },
        user: {
          label: "Cliente",
          placeholder: "Selecciona el cliente.",
        },
        reference: {
          label: "Referencia",
          placeholder: "Introduce la referencia.",
        },
        number: {
          label: "Número",
          placeholder: "Introduce el número.",
        },
      },
    },
    confirmCancellation: {
      title: "Cancelar movimiento",
      content: "Favor de confirmar que desea cancelar el movimiento #{code}.",
      okText: "Sí, cancelar",
      cancelText: "Cerrar",
    },
    cancelTransferSuccess: "Movimiento cancelado exitosamente.",
    cancelTransferError: "Ocurrio un error al cancelar el movimiento.",
    moreInfo: {
      title: "Información de movimiento {code}",
      date: "Fecha",
      code: "Número",
      reference: "Ticket/Referencia",
      type: "Tipo",
      origin: "Origen",
      amount: "Monto",
      status: "Estado",
    },
  },
  userbalancemovementRegularization: {
    title: "Regularización de saldo",
    subtitle: "Regularizar movimientos y balance del cliente.",
    balanceTitle: "Balance del cliente",
    currentBalanceLabel: "Balance actual",
    newBalanceLabel: "Nuevo balance",
    error: "Ocurrio un error al regularizar el balance.",
    success: "Balance regularizado exitosamente.",
    loadError: "Ocurrio un error al cargar los movimientos.",
    userRequired: "Debe seleccionar un cliente.",
    errors: {
      user: "Debe seleccionar un cliente.",
      dataSource: "No hay movimientos para regularizar.",
    },
    filters: {
      user: {
        label: "Cliente",
        placeholder: "Selecciona el cliente.",
      },
      search: "Cargar movimientos",
    },
    form: {
      btnRegularize: "Regularizar",
      regularize: {
        label: "Regularizar balance del cliente",
      },
      balance: {
        label: "Balance",
        placeholder: "0.00",
      },
      buttonText: "Regularizar",
    },
    table: {
      emptyText: "No se encontraron movimientos.",
      columns: {
        date: "Fecha",
        type: {
          title: "Tipo",
          DEBIT: "Débito",
          CREDIT: "Crédito",
        },
        currentBalance: "Balance actual",
        amount: "Monto",
        newBalance: "Nuevo balance",
        movements: "Movimientos",
      },
    },
    confirmRegularization: {
      title: "Regularizar balance",
      help: "Al regularizar el balance del cliente su nuevo saldo será el indicado en el campo, ¿Desea continuar?",
      confirmButtonText: "Sí, regularizar",
      cancelButtonText: "Cerrar",
    },
  },
  monitoringReport: {
    title: "Reporte de monitoreo",
    subtitle: "Reporte de monitoreo de jugadas",
    table: {
      emptyText: "No se encontraron jugadas.",
      columns: {
        lottery: "Loteria",
        date: "Fecha",
        type: "Tipo",
        numbers: "Números",
        percentage: "Porcentaje",
        amount: "Monto",
        amountToWin: "A ganar",
        closeTime: "Cierre",
        plays: "Jugadas",
      },
    },
  },
  lotteriesSchedules: {
    title: "Programación cierre de loterias",
    pageTitleCreate: "Crear programación",
    pageTitleEditing: "Editando programación",
    subtitle: "Lista de programación de cierre de loterias",
    add: "Añadir",
    edit: "Editar",
    delete: "Eliminar",
    placeholderSearch: "Buscar título, fecha y loterías.",
    deletedSuccess: "Programación eliminada exitosamente.",
    deleteError: "Ocurrio un error al eliminar la programación.",
    table: {
      emptyText: "No se encontraron programaciones.",
      columns: {
        lotteriesSchedule: "Programación de cierre de loterias",
        date: "Fecha",
        lotteries: "Loterias",
        title: "Título",
        annually: {
          title: "Anual",
          yes: "Si",
          no: "No",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro que deseas eliminar esta programación?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      titleEdit: "Editar programación",
      titleAdd: "Añadir programación",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      date: {
        label: "Fecha",
        placeholder: "Selecciona una fecha.",
      },
      title: {
        label: "Título",
        placeholder: "Introduce el título.",
      },
      lotteries: {
        label: "Loterias",
        placeholder: "Selecciona una o más loterias.",
        required: "Debe seleccionar al menos una loteria.",
        min: (min) => `Debe seleccionar al menos ${min} loteria(s).`,
      },
      annually: {
        label: "Anual",
        placeholder: "¿Repetir anualmente?",
        yes: "Si",
        no: "No",
      },
    },
  },

  userNotificationsList: {
    title: "Notificaciones",
    subtitle: "Listado de notificaciones del sistema",
    placeholderSearch: "Buscar por número, tipo o fecha.",
    table: {
      emptyText: "No se encontraron notificaciones.",
      columns: {
        date: "Fecha",
        subject: "Asunto",
        message: "Mensaje",
        read: "Estado",
        // new: "Nuevo",
        // topic: "Tipo",
        // sender: "Usuario",
        action: "Acciones",
      },
    },
    filters: {
      title: "Aplicar filtros",
      filters: "Filtros",
      form: {
        dateRange: {
          label: "Rango de fechas",
          placeholder: {
            startdate: "Fecha inicial",
            enddate: "Fecha final",
          },
        },
      },
    },
    // confirmRead: {
    //   title: "Marcar como Leída",
    //   content: "Favor de confirmar que desea cancelar el estado.",
    //   okText: "Sí",
    //   cancelText: "Cerrar",
    // },
    read: {
      true: "Leída",
      false: "No leída",
    },
    actions: {
      moreInfo: "Ver detalle",
      delete: {
        title: "¿Estás seguro de eliminar esta notificación?",
        content: "Esta acción no se puede deshacer.",
        okText: "Sí, eliminar",
        cancelText: "Cerrar",
      },
    },
    moreInfo: {
      mainTitle: "Información de la notificación {code}",
      subject: "Asunto",
      date: "Fecha",
      topic: "Tipo",
      sender: "Enviado por",
      message: "Mensaje",
      body: "Detalle",
    },
  },
  welcomePage: {
    title: "Página de bienvenida",
    subtitle: "Configuración de la página de bienvenida",
    description: "Página de bienvenida",
    loading: "Cargando...",
    playNow: "Juega ahora",
  },

  verifyPhoneForm: {
    title: "Verifica tu número de teléfono",
    subtitle: "Estas solo a aun paso de finalizar, verifica tu número",
    subtitle_bonus:
      "Confirma tu número de teléfono y gana un bono de bievenida de {variable}",
    before: "Un código de verificación será enviado al número {phone}",
    after: "Acabamos de enviar un código al {phone}",
    form: {
      code: {
        label: "introducir código de verificación",
        placeholder: "",
      },
      sent_success: "Código enviado.",
      success: "Validación correcta.",
      error: "Validación incorrecta.",
      error_code: "El código no es válido, intenta nuevamente.",
      submit: "Verificar",
      send: "Enviar",
    },
  },
  confirmPromotion: {
    title: "Aplicar promoción",
    subtitle: "Escribe el código de la promoción",
    appliedSuccess: "Promoción aplicada exitosamente.",
    appliedError: "Ocurrio un error al aplicar la promoción.",
    code: {
      label: "Código de promoción",
      placeholder: "Introduce el código de promoción",
      required: "El código de promoción es requerido.",
    },
    confirmButtonText: "Aplicar",
    cancelButtonText: "Cancelar",
  },
  anguillaPool: {
    title: "Anguilla Pool",
    loadingText: "Cargando Anguilla Pool...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  flashDraw: {
    title: "Sorteo Flash",
    loadingText: "Cargando sorteo flash...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  flashRoulette: {
    title: "Ruleta Flash",
    loadingText: "Cargando ruleta flash...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  liveLottery: {
    title: "Loteria en vivo",
    loadingText: "Cargando loteria en vivo...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  dogRacing: {
    title: "Juegos Virtuales",
    loadingText: "Cargando juegos virtuales...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  lotoScratch: {
    title: "Raspaditas",
    loadingText: "Cargando raspadita...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  roulettes: {
    title: "Ruletas",
    loadingText: "Cargando ruletas...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  parchis: {
    title: "Parchis Time",
    loadingText: "Cargando Parchis Time...",
    noAuthToken: "No se ha proporcionado un token de autenticación.",
    errorLoadingIframe:
      "Ocurrió un error al cargar el contenido, por favor refresca la página e intenta de nuevo.",
    goToHome: "Ir a la página de inicio",
    notAllowed: "No tienes permisos para ver esta página.",
  },
  ads: {
    title: "Anuncios",
    subtitle: "Listado de anuncios",
    placeholderSearch: "Buscar por título.",
    add: "Añadir",
    deletedSuccess: "Anuncio eliminado exitosamente.",
    deleteError: "Ocurrio un error al eliminar el anuncio.",
    pageTitleViewing: "Viendo anuncio",
    pageTitleCreate: "Crear anuncio",
    table: {
      emptyText: "No se encontraron anuncios.",
      columns: {
        id: "ID",
        title: "Título",
        type: {
          title: "Tipo",
          image: "Imagen",
          video: "Video",
          html: "HTML",
        },
        width: "Ancho",
        height: "Alto",
        content: "Contenido",
        link: "Redireccionar a",
        priority: "Prioridad",
        active: {
          title: "Estado",
          yes: "Activo",
          no: "Inactivo",
        },
        startDate: "Fecha inicio",
        endDate: "Fecha fin",
        action: {
          title: "Acciones",
          edit: "Editar",
          delete: "Eliminar",
        },
      },
    },
    confirm: {
      title: "¿Estás seguro que deseas eliminar este anuncio?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    },
    form: {
      titleForm: "Información de",
      titleView: "Anuncio",
      titleCreate: "Crear anuncio",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      deleteAd: "Eliminar",
      file: {
        label: "Cargar archivo",
        placeholder: "Selecciona el archivo.",
        error: "El archivo no es válido.",
      },
      title: {
        label: "Título",
        placeholder: "Introduce el título.",
      },
      type: {
        label: "Tipo",
        placeholder: "Selecciona el tipo.",
        image: "Imagen",
        video: "Video",
        html: "HTML",
      },
      width: {
        label: "Ancho (px|%)",
        placeholder: "Introduce el ancho.",
      },
      height: {
        label: "Alto (px|%)",
        placeholder: "Introduce el alto.",
      },
      content: {
        label: "Contenido",
        placeholder: "Introduce el contenido.",
      },
      link: {
        label: "Redireccionar a",
        placeholder: "Introduce la URL.",
      },
      priority: {
        label: "Prioridad",
        placeholder: "Selecciona la prioridad.",
      },
      onlyLoggedIn: {
        label: "Mostrar solo a usuarios logueados",
        placeholder: "¿Mostrar solo a usuarios logueados?",
      },
      position: {
        label: "Posición",
        placeholder: "Selecciona la posición.",
        top: "Arriba",
        bottom: "Abajo",
        center: "Centro",
        left: "Izquierda",
        right: "Derecha",
        full: "Completo",
      },
      active: {
        label: "Estado",
        placeholder: "Selecciona el estado.",
        yes: "Activo",
        no: "Inactivo",
      },
      startDate: {
        label: "Fecha inicio",
        placeholder: "DD/MM/AAAA",
      },
      endDate: {
        label: "Fecha fin",
        placeholder: "DD/MM/AAAA",
      },
      targetUsers: {
        label: "Usuarios",
        placeholder: "Selecciona el/los usuarios destino(s).",
        all: "Todos los usuarios",
        specific: "Usuarios específicos",
      },
      show_multiple_times: {
        label: "Mostrar múltiples veces",
        placeholder: "¿Mostrar múltiples veces?",
      },
      show_interval_hours: {
        label: "Intervalo de repetición (horas)",
        placeholder: "Horas entre cada muestra (ej: 24)",
      },
      import_users: "Importar usuarios masivamente",
    },
  },
  promotionsPage: {
    title: "Promociones",
    subtitle: "Mis promociones",
    promotionForm: {
      apply: "Aplicar",
      title: "Aplicar promoción",
      subtitle: "Escribe el código de la promoción",
      appliedSuccess: "Promoción aplicada exitosamente.",
      appliedSuccessTitle: "Promoción aplicada",
      appliedError: "Ocurrió un error al aplicar la promoción.",
      formError: "Ocurrió un error al aplicar la promoción.",
      alreadyAppliedTitle: "Promoción ya aplicada",
      invalidPromotionTitle: "Código de promoción no válido",
      errorTitle: "No se pudo aplicar la promoción",
      code: {
        label: "Código de promoción",
        placeholder: "Introduce el código de promoción",
        required: "El código de promoción es requerido.",
      },
      submit: "Aplicar",
      alreadyAppliedOkText: "Cerrar",
    },
    table: {
      emptyText: "No se encontraron promociones.",
      ticketsTitle: "Mis tickets promocionales",
      okText: "Cerrar",
      title: "Rifas promocionales",
      subtitle: "Lista de rifas promocionales en las que participas",
      columns: {
        title: "Título",
        tickets: "Tickets",
        module: "Operación",
        ticketNumber: "Ticket #",
        ticketBtnTitle: "Click para ver tickets",
        date: "Fecha",
        status: {
          title: "Estado",
          closed: "Cerrada",
          initiated: "En curso",
        },
      },
    },
    dailyRaffle: {
      title: "Concurso diario",
      subtitle: "Premio acumulado del concurso",
      subtitle2: "Premio especial del día",
      timeout: "Cuenta regresiva",
      hour: "Hora",
      minute: "Minuto",
      second: "Segundo",
    },
    lasWinner: {
      title: "Último ganador",
    },
  },
  workingHours: {
    title: "Horarios",
    subtitle: "Listado de horarios",
    placeholderSearch: "Buscar por título o descripción",
    pageTitleViewing: "Viendo horario",
    table: {
      emptyText: "No se encontraron horarios.",
      columns: {
        id: "ID",
        title: "Título",
        description: "Descripción",
        today_enabled: {
          title: "Hoy (habilitado)",
          yes: "Si",
          no: "No",
        },
        today_start: "Hoy (inicio)",
        today_end: "Hoy (fin)",
        status: {
          title: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
        },
      },
    },
    form: {
      titleView: "Horario",
      save: "Guardar",
      saveAndClose: "Guardar & cerrar",
      goBack: "Atrás",
      loading: "Cargando...",
      title: {
        label: "Título",
        placeholder: "Introduce el título.",
      },
      description: {
        label: "Descripción",
        placeholder: "Introduce la descripción.",
      },
      monday: {
        label: "Lunes",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      tuesday: {
        label: "Martes",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      wednesday: {
        label: "Miércoles",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      thursday: {
        label: "Jueves",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      friday: {
        label: "Viernes",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      saturday: {
        label: "Sábado",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      sunday: {
        label: "Domingo",
        enabled: "Habilitado",
        start: {
          label: "Inicio",
          placeholder: "HH:MM",
        },
        end: {
          label: "Fin",
          placeholder: "HH:MM",
        },
      },
      status: {
        label: "Estado",
        placeholder: "Selecciona el estado.",
        active: "Activo",
        inactive: "Inactivo",
      },
    },
  },
  identityVerifications: {
    title: "Verificaciones de identidad",
    subtitle: "Listado de solicitudes de verificación de identidad",
    placeholderSearch: "Buscar por usuario.",
    viewDocument: "Ver documento",
    statuses: {
      pending: "Pendiente",
      approved: "Aprobado",
      rejected: "Rechazado",
      all: "Todos",
    },
    table: {
      emptyText: "No se encontraron solicitudes de verificación de identidad.",
      columns: {
        user: "Usuario",
        dfp: "Documento (Frontal)",
        dbp: "Documento (Posterior)",
        selfie: "Selfie",
        status: {
          title: "Estado",
        },
        createdAt: "Fecha",
        action: {
          title: "Acciones",
          view: "Ver",
        },
      },
    },
    view: {
      title: "Revisión de verificación de identidad",
      rejectedSuccess: "Verificación de identidad rechazada exitosamente.",
      approvedSuccess: "Verificación de identidad aprobada exitosamente.",
      rejectedError:
        "Ocurrio un error al rechazar la verificación de identidad.",
      approvedError:
        "Ocurrio un error al aprobar la verificación de identidad.",
      user: "Usuario",
      documents: "Documentos",
      documentFront: "Documento (Frontal)",
      documentFrontDescription: "Imagen del frente del documento de identidad.",
      documentBack: "Documento (Posterior)",
      documentBackDescription: "Imagen del reverso del documento de identidad.",
      selfie: "Selfie",
      selfieDescription: "Imagen selfie del usuario sosteniendo su documento.",
      loading: "Cargando...",
      userInfo: "Información del usuario",
      userName: "Nombre",
      userEmail: "Email",
      userBirthdate: "Fecha de nacimiento (DD/MM/YYYY)",
      userBirthdatePlaceholder: "Selecciona la fecha de nacimiento",
      goBack: "Atrás",
      reject: "Rechazar",
      approve: "Aprobar",
      status: {
        label: "Estado",
      },
      createdAt: {
        label: "Fecha",
      },
      sendUserNotification: "¿Enviar notificación al usuario?",
      notes: {
        label: "Notas",
        placeholder: "Escribe las notas aquí...",
      },
      reviewedAt: {
        label: "Revisado el",
      },
      reviewedBy: {
        label: "Revisado por",
      },
      statusHistory: {
        title: "Historial de estados",
        date: "Fecha",
        status: "Estado",
        notes: "Notas",
      },
    },
    confirmReject: {
      title:
        "¿Estás seguro que deseas rechazar esta verificación de identidad?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Rechazar",
      cancelButtonText: "Cancelar",
    },
    confirmApprove: {
      title: "¿Estás seguro que deseas aprobar esta verificación de identidad?",
      subtitle: "Esta acción no se puede deshacer.",
      confirmButtonText: "Aprobar",
      cancelButtonText: "Cancelar",
    },
  },
  emailTemplates: {
    title: "Plantillas de correo",
    subtitle: "Listado de plantillas de correo",
    placeholderSearch: "Buscar por nombre o asunto.",
    table: {
      emptyText: "No se encontraron plantillas de correo.",
      columns: {
        name: "Nombre",
        from: "De",
        subject: "Asunto",
        active: {
          title: "Estado",
          yes: "Activo",
          no: "Inactivo",
        },
        action: {
          title: "Acciones",
          edit: "Editar",
        },
      },
    },
    pageTitleEditing: "Editando plantilla de correo",
    form: {
      title: "Información de plantilla de correo",
      update: "Actualizar",
      goBack: "Atrás",
      loading: "Cargando...",
      saveAndClose: "Guardar & cerrar",
      save: "Guardar",
      status: {
        label: "Estado",
        placeholder: "Selecciona el estado.",
        active: "Activo",
        inactive: "Inactivo",
      },
      name: {
        label: "Nombre",
        placeholder: "Introduce el nombre.",
      },
      subject: {
        label: "Asunto",
        placeholder: "Introduce el asunto.",
      },
      from: {
        label: "De",
        placeholder: "Introduce el remitente.",
      },
      body: {
        label: "Cuerpo",
        placeholder: "Introduce el cuerpo del correo.",
      },
      to: {
        label: "Para",
        placeholder: "Introduce el destinatario.",
      },
      cc: {
        label: "CC",
        placeholder: "Introduce el CC.",
      },
      bcc: {
        label: "BCC",
        placeholder: "Introduce el BCC.",
      },
    },
  },
  redisQuotas: {
    title: "Cuotas Redis",
    subtitle: "Listado de cuotas por número y lotería en tiempo real",
    placeholderSearch: "Buscar...",
    tabs: {
      profile: "Bloqueos por Perfil",
      global: "Límites Globales",
    },
    table: {
      emptyText: "No se encontraron resultados.",
      columns: {
        profile: "Perfil",
        lottery: "Lotería",
        date: "Fecha",
        count: "Jugadas",
        numbers: "Números",
        unblocked: "Desbloqueados",
        remaining: "Saldo Restante",
        type: "Tipo",
        action: {
          title: "Acciones",
          unblock: "Desbloquear número",
          moreInfo: "Más información",
          update: "Ajustar Saldo",
          logs: "Ver Historial",
        },
        quotas: "Cuotas",
      },
    },
    unblock: {
      title: "Desbloquear número",
      content:
        "¿Estás seguro de que deseas desbloquear el número {number} para la lotería {lottery}?",
      okText: "Desbloquear",
      cancelText: "Cancelar",
      success: "Número desbloqueado exitosamente.",
      error: "Ocurrió un error al desbloquear el número.",
      confirmTitle: "Confirmación de desbloqueo",
    },
    globalLimits: {
      updateTitle: "Ajustar Saldo Global",
      updateLabel: "Nuevo Saldo Base",
      updateHelp:
        "Este monto será el nuevo límite disponible para este número.",
      updateSuccess: "Monto actualizado exitosamente.",
      updateError: "Ocurrió un error al actualizar el monto.",
      logsTitle: "Historial de Modificaciones",
      logsTable: {
        admin: "Administrador",
        date: "Fecha",
        oldValue: "Valor Anterior",
        newValue: "Valor Nuevo",
      },
      emptyLogs: "No hay modificaciones registradas para este número.",
    },
    filters: {
      title: "Filtrar por",
      lottery: {
        label: "Lotería",
        placeholder: "Selecciona una lotería",
      },
      profile: {
        label: "Perfil",
        placeholder: "Selecciona un perfil",
      },
      date: {
        label: "Fecha",
        placeholder: "Selecciona una fecha",
      },
      type: {
        label: "Tipo de Jugada",
        placeholder: "Selecciona un tipo",
      },
      save: "Aplicar",
      cancel: "Cerrar",
    },
  },
};

export default labels;
